import { Language } from "@/data/model/Enums";
import { isTestProject } from "@/data/util/Config";

import { clientLanguage } from "@/shared/localization/language";

export let trans: {
    allocation: {
        headline: string;
        scanHint: string;
        scanQrBtn: string;
        disclaimer: string;
        cameraFailed: string;
        allocationFailed: string;
        tableDoesNotExist: string;
        locationSuspended: string;
        title: string;
        enterCode: string;
        or: string;
        doYouHaveOpenBill: string;
    };
    notification: {
        allow: string;
        dontAllow: string;
        notificationPermission: string;
        notifiedWhenOrderReadyWithDuration: string;
        notifiedWhenOrderReadyWithPosition: string;
        notificationsDenied: string;
        enableNotificationFailed: string;
        checkIfPrivateMode: string;
        onMyWay: string;
        pickUpOrderTitle: string;
        orderReadyToPickUp: string;
        orderScheduled: string;
        browserNotSupportNotifications: string;
    };
    order: {
        title: string;
        itemsSelected: string;
        loadingOffer: string;
        noOffer: string;
        cancellationSuccessful: string;
        cancel: string;
    };
    creditCard: {
        title: string;
        failedRemove: string;
        expired: string;
        ccHolder: string;
        ccNumber: string;
        ccExpiry: string;
        ccCvc: string;
        confirmDelete: string;
        deleteBtn: string;
    };
    orderHistory: {
        title: string;
        confirmation: string;
        loadingOrders: string;
        noOrders: string;
    };
    paymentHistory: {
        title: string;
        noPayments: string;
        loadingPayments: string;
    };
    receipt: {
        title: string;
        loading: string;
        sendReceipt: string;
        sendReceiptEmail: string;
        receiptPrinted: string;
        total: string;
        failedLoadingOrder: string;
        failedSendReceipt: string;
        payment: string;
        printReceipt: string;
        receipt: string;
    };
    cart: {
        title: string;
        itemsSelected: string;
        failedToRemove: string;
        failedToAdd: string;
        failedToChange: string;
        minimumChf: string;
        paymentBlockingCart: string;
        noItems: string;
        backToOverview: string;
        haveItemsInCart: string;
    };
    print: {
        failedPrintReceipt: string;
        noProductionSiteEnabledForRoom: string;
        orderReceiptPrinted: string;
        printReceipt: string;
    };
    pay: {
        title: string;
        discount: string;
        total: string;
        paying: string;
        disclaimer: string;
        contactingAquirer: string;
        signup: string;
        signupBenefits: string;
        btnSuccessful: string;
        btnFailed: string;
        preparingCardForm: string;
        failedAuthorization: string;
        failedCartIsOutdated: string;
        failedOfferExpired: string;
        failedCartIsEmpty: string;
        failedOrderIsClosed: string;
        orderWithStaff: string;
        order: string;
        ordering: string;
        provideEmailMessage: string;
    };
    done: {
        signupAndReceipt: string;
        getReceipt: string;
        startOver: string;
        fullyPaid: string;
        disclaimer: string;
        onlyReceipt: string;
        signupAndReceiptBtn: string;
        weSentReceipt: string;
        weSentConfirmation: string;
        signupHintTitle: string;
        signupHintText: string;
        failedSignup: string;
        trxCheckingTitle: string;
        trxCheckingText: string;
        trxSuccessTitle: string;
        trxDeclinedTitle: string;
        trxDeclinedText: string;
        trxFailedCheckingTitle: string;
        trxFailedCheckingText: string;
        backToOrder: string;
        backToPayment: string;
        displayOrderBtn: string;
        displayPaymentBtn: string;
        title: string;
        more: string;
        displayOrderHeadline: string;
        displayPaymentHeadline: string;
        signup: string;
        unpaid: string;
    };
    cancelOrderPopover: {
        offlineMode: string;
        title: string;
        wholeOrderText: string;
        cancellationFailed: string;
        yesCancel: string;
    },
    orderReceivedPopover: {
        plannedPickUpTime: string;
        received: string;
        hint: string;
        receiptAndMore: string;
        more: string;
        copyAddress: string;
        googleMapsLocation: string;
    };
    paymentReceivedPopover: {
        received: string;
        unpaid: string;
        more: string;
        fullyPaid: string;
    };
    tableSelectionPopover: {
        title: string;
        tableNumber: string;
        welcomeTo: string;
        hint: string;
    };
    tableInfoPopover: {
        title: string;
        textFieldLbl: string;
        hint: string;
    };
    phoneNumberPopover: {
        title: string;
        phoneNumber: string;
        disclaimer: string;
        submitBtn: string;
        failed: string;
    };
    covidSignupPopover: {
        title: string;
        certificateTitle: string;
        createAccount: string;
        deleteAfterDays: string;
        signupBtn: string;
        signInBtn: string;
        onlyCoronaBtn: string;
        firstName: string;
        lastName: string;
        birthday: string;
        phone: string;
        disclaimer: string;
        certDataProtection: string;
        certificateExpired: string;
        failedUpload: string;
        failedInvalidMode: string;
        failedToDecode: string;
        failedToReadQr: string;
        failedBecauseInvalid: string;
        failedIdDocUnkown: string;
        failedIdDocInvalid: string;
        failedMissmatch: string;
        failedDuplicate: string;
        uploadCertName: string;
        uploadSecondaryCertName: string;
        uploadCertDesc: string;
        uploadSecondaryCertDesc: string;
        uploadIdName: string;
        uploadIdDesc: string;
        verifyBtn: string;
        stateUploadingFiles: string;
        stateValidatingCertificate: string;
        stateValidatingIdentity: string;
        stateDecryptAndStore: string;
        submit: string;
        back: string;
        failed: string;
        disablePrivate: string;
    };
    minimumAgePopover: {
        title: string;
        text: string;
        confirm: string;
        cancel: string;
    };
    fulfillmentPopover: {
        title: string;
        currentTime: string;
        emptyGroup: string;
        didYouGetEverything: string;
        didYouGetWholeOrder: string;
        yesGotIt: string;
        showWhenPickingUpOrder: string;
        readyForPickUp: string;
        xItemsInMyOrder: string;
    };
    addToCartPopover: {
        price: string;
        optional: string;
        optionSing: string;
        optionPlur: string;
        chooseExact: string;
        chooseMin: string;
        chooseUpTo: string;
        chooseBetween: string;
        upToTotalItems: string;
        chooseOption: string;
        loadingOptions: string;
        failedLoadingOptions: string;
        adding: string;
    };
    signin: {
        title: string;
        email: string;
        password: string;
        repeatPassword: string;
        resetPasswordTitle: string;
        resetPassword: string;
        setNewPassword: string;
        reset: string;
        loginWith: string;
        login: string;
        signup: string;
        logout: string;
        backToLogin: string;
        checkYourInbox: string;
        resetSuccess: string;
        resetFailed: string;
        signinFailed: string;
        externalAuthFailed: string;
    };
    signup: {
        title: string;
        firstName: string;
        lastName: string;
        phoneNumber: string;
        zip: string;
        disclaimer: string;
        submit: string;
        signin: string;
        signupWithMail: string;
        signupFailed: string;
        emailConfirmSuccess: string;
        emailConfirmFailed: string;
        emailAlreadyUsed: string;
    };
    enterCode: {
        title: string;
        codeVerificationFailed: string;
        digitCode: string;
        pasteCode: string;
    };
    profile: {
        title: string;
        emailConfirmed: string;
        emailUnconfirmed: string;
        changePassword: string;
        currentPassword: string;
        newPassword: string;
        onlyImageFiles: string;
        updateBtn: string;
        resendConfirmation: string;
        failedResend: string;
        failedSave: string;
        profileSaved: string;
        confirmationSent: string;
    };
    navigation: {
        profile: string;
        leaveTable: string;
        help: string;
        creditCards: string;
        reports: string;
        orderHistory: string;
        paymentHistory: string;
        logout: string;
        login: string;
        signup: string;
        guest: string;
        switchIdentity: string;
    };
    help: {
        helpTitle: string;
        helpLead: string;
        helpText: string;
        rateTitle: string;
        issueTitle: string;
        rateTastierBtn: string;
        reportProblemBtn: string;
        rateLead: string;
        rateText: string;
        rating: string;
        reportProblem: string;
        howImprove: string;
        sendBtn: string;
        ratingSuccessful: string;
        reportIssueSuccessful: string;
        failedRate: string;
        failedReportIssue: string;
    };
    documents: {
        loading: string;
        failedToLoad: string;
        noData: string;
    };
    covid: {
        title: string;
        letsgo: string;
        checkout: string;
        clickBeforeYouGo: string;
        guestNumber: string;
        welcome: string;
        validatingCertificate: string;
    };
    bill: {
        title: string;
        waitingForOrder: string;
        discount: string;
        continue: string;
        fullyPaidItems: string;
        paid: string;
        exclTip: string;
        clearSelection: string;
        selectAll: string;
        noOrderYet: string;
        fullyPaid: string;
        allItems: string;
        selectedItems: string;
    };
    messages: {
        unauthorizedPleaseRefresh: string;
    };
    general: {
        pleaseSelect: string;
        close: string;
        done: string;
        ok: string;
        continue: string;
        save: string;
        edit: string;
        add: string;
        cancel: string;
        confirm: string;
        understood: string;
        operationFailed: string;
        optional: string;
        verify: string;
        today: string;
        date: string;
        time: string;
        accept: string;
        yes: string;
        shortWeekDay: {
            Sunday: string;
            Monday: string;
            Tuesday: string;
            Wednesday: string;
            Thursday: string;
            Friday: string;
            Saturday: string;
        };
        copied: string;
    };
    passwordStrength: {
        minLength: string;
        upperCase: string;
        lowerCase: string;
        digit: string;
    };
    enums: {
        cancellationMode: {
            Amount: string,
            Positions: string,
            WholeOrder: string,
        },
        paymentMethodMode: {
            Online: string;
            Offline: string;
        };
        serviceType: {
            Covid: string;
            Documents: string;
            Order: string;
            Ticketing: string;
            Website: string;
            Offer: string;
            Pay: string;
            RoomPlan: string;
        };
    };
    preloadingSteps: {
        assets: string;
        domStructure: string;
        identity: string;
        paymentProvider: string;
    };
    addToHomeScreen: {
        title: string;
        step1: string;
        step2: string;
        step3: string;
    };
    voucher: {
        invalidCode: string;
        codeExpired: string;
        codeNotApplicable: string;
        codeUsed: string;
        voucherCodeAlreadyApplied: string;
    };
    app: {
        title: string;
    };
    paymentMethodsReport: {
        paymentMethodsReport: string;
        paymentMethod: string;
        netQuantity: string;
        grossSalesNetChfInclTip: string;
        grossSalesPercent: string;
        cancellationQuantity: string;
        quantity: string;
        grossSalesAvg: string;
        tipNet: string;
        grossNetSales: string;
        dateRangeGenerated: string;
    };
    paymentMethodSelector: {
        noPaymentMethodConfigured: string;
    };
    temporaryChange(transVals?: Array<{ valueDe: string; valueEn: string; valueFr: string; valueIt: string }>);
};

const setEnglish = () => {
    trans = {
        allocation: {
            headline: "Served better",
            scanQrBtn: "Scan QR Code",
            scanHint: "Click button to start",
            disclaimer: 'By using Tastier\'s services I confirm to have read, understood and accepted Tastier Ltd.\'s <a href="https://www.tastier.ch/terms-of-use-for-users/" target="_blank">Terms of Use</a> and <a href="https://www.tastier.ch/dataprivacy/" target="_blank">Privacy Policy.</a>',
            cameraFailed: "Camera access denied. Please grant Tastier access to the camera in browser settings (clear website data / settings) and try again.",
            tableDoesNotExist: "Unfortunately, this number is currently not activated. Please correct the entry or contact the personnel or Tastier.",
            locationSuspended: "Unfortunately, this location is currently not activated. Please contact the staff or Tastier.",
            allocationFailed: "Unfortunately, check-in failed. Please reload the page and try again.",
            title: "Welcome",
            enterCode: "Enter 6-Digit Code",
            or: "or",
            doYouHaveOpenBill: "Do you have an open order / bill?<br />Please do again what initially brought you here (e.g. click the link / button, scan the QR code).",
        },
        notification: {
            allow: "Yes",
            dontAllow: "No",
            notificationPermission: "Want to receive a notification when your order is ready? Otherwise you have to check your browser frequently to not miss your order.",
            notifiedWhenOrderReadyWithDuration: "You'll be notified when your order is ready for pick-up. Expected waiting time (indicative, may change anytime):",
            notifiedWhenOrderReadyWithPosition: "You'll be notified when your order is ready for pick-up. Current position on the waiting list:",
            notificationsDenied: "You rejected notifications. Do not close this browser tab and check it frequently for updates.",
            enableNotificationFailed: "Your browser / device cannot receive notifications. Do not close this browser tab and check it frequently for updates.",
            checkIfPrivateMode: "Next time, we recommend not using private / incognito mode.",
            onMyWay: "Display Pick-Up Screen",
            pickUpOrderTitle: "Pick up order",
            orderReadyToPickUp: "Your order is ready for pick-up",
            orderScheduled: "Your order will be ready for pick-up soon",
            browserNotSupportNotifications: "Your browser / Apple device cannot receive notifications. Do not close this browser tab and check it frequently for updates.",
        },
        order: {
            title: "Order",
            loadingOffer: "Offer is being loaded...",
            itemsSelected: "{0} item(s) selected",
            noOffer: "Unfortunately there is no offer available at the moment.",
            cancellationSuccessful: "Cancellation successful",
            cancel: "Cancel",
        },
        cart: {
            title: "Cart",
            itemsSelected: "{0} item(s)",
            failedToAdd: "Item could not be added.",
            failedToRemove: "Item could not be removed.",
            failedToChange: "Item could not be modified.",
            minimumChf: "at least {0}",
            paymentBlockingCart: "The cart cannot be adjusted while a payment is in progress.",
            noItems: "No items have been added to the cart yet.",
            backToOverview: "To the offer overview",
            haveItemsInCart: "You have items in your {0} cart. If you continue, your cart will be deleted.",
        },
        print: {
            orderReceiptPrinted: "Print job sent",
            failedPrintReceipt: "Print job failed",
            noProductionSiteEnabledForRoom: "No activated receipt printer is assigned to this table / room.",
            printReceipt: "Print Receipt",
        },
        pay: {
            title: "Payment",
            discount: "Discount",
            total: "Total",
            paying: "Paying...",
            disclaimer: 'Tastier <a href="https://www.tastier.ch/terms-of-use-for-users/" target="_blank">ToU</a> & <a href="https://www.tastier.ch/dataprivacy/" target="_blank">Privacy</a>, Provider T&C apply.',
            contactingAquirer: "Please wait...",
            signup: "Sign Up",
            signupBenefits: "Optional. Benefits: Save payment methods, receipts automatically by email, order history",
            btnFailed: "Failed",
            btnSuccessful: "Successful",
            preparingCardForm: "Loading form...",
            failedAuthorization: "Payment method could not be charged.",
            failedCartIsOutdated: "You have tried to pay an outdated cart, please refresh the website.",
            failedCartIsEmpty: "You are trying to pay an empty cart.",
            failedOfferExpired: "At least one item in your cart is no longer available.",
            failedOrderIsClosed: "The order is already fully paid.",
            orderWithStaff: "Order with the staff",
            order: "Order",
            ordering: "Ordering...",
            provideEmailMessage: "Please enter your email or sign up",
        },
        done: {
            fullyPaid: "Bill fully paid",
            startOver: "Continue",
            signupAndReceipt: "Get Receipt & Sign Up",
            getReceipt: "Get Receipt",
            disclaimer: "You may occasionally receive communication from Tastier, from which you can unsubscribe at any time.",
            onlyReceipt: "Only get receipt",
            signupAndReceiptBtn: "Sign Up & Send Receipt",
            weSentReceipt: "We have sent your receipt to",
            weSentConfirmation: "We have sent your confirmation to",
            failedSignup: "Sign-Up failed. Please try again.",
            signupHintTitle: "Receipt by email",
            signupHintText: "Enter your email to receive a receipt. And set a password to make it even easier to pay with a Tastier account next time (without entering the payment method) and to have Tastier receipts sent to you automatically.",
            trxCheckingTitle: "Payment in progress",
            trxCheckingText: "Please wait...",
            trxSuccessTitle: "Payment successful",
            trxDeclinedTitle: "Payment failed",
            trxDeclinedText: "Please try again",
            trxFailedCheckingTitle: "Payment not confirmed",
            trxFailedCheckingText: "Time limit exceeded",
            backToOrder: "Place New Order",
            backToPayment: "Make a new payment",
            displayOrderBtn: "Display Order",
            displayPaymentBtn: "Display payment",
            title: "Receipt & More",
            more: "More",
            displayOrderHeadline: "My Order",
            displayPaymentHeadline: "My Payment",
            signup: "Sign up",
            unpaid: "Unpaid",
        },
        cancelOrderPopover: {
            title: "Cancellation",
            offlineMode: "Offline refund",
            wholeOrderText: "The entire order will be cancelled.",
            cancellationFailed: "Order could not be cancelled.",
            yesCancel: "Yes, cancel",
        },
        orderReceivedPopover: {
            plannedPickUpTime: "Planned pick-up time",
            received: "Order Received",
            hint: '"Tastier" will appear on your statement',
            receiptAndMore: "Receipt & More",
            more: "More",
            copyAddress: "Copy address",
            googleMapsLocation: "Google Maps location",
        },
        paymentReceivedPopover: {
            received: "Payment Received",
            unpaid: "Unpaid",
            more: "More",
            fullyPaid: "Bill fully paid",
        },
        tableSelectionPopover: {
            title: "Table Selection",
            tableNumber: "Table number",
            welcomeTo: "Welcome to",
            hint: "Please ask the server for your table number, if it isn’t displayed or in case of any issues.",
        },
        tableInfoPopover: {
            title: "Where do you want to go?",
            textFieldLbl: "Exact destination (person / table / area)",
            hint: "Please enter your exact destination so that it can later be clearly and unambiguously traced where you have been.",
        },
        phoneNumberPopover: {
            title: "Data Completion",
            phoneNumber: "Phone number",
            disclaimer: "Please enter this information",
            submitBtn: "Save",
            failed: "Failed to save data",
        },
        covidSignupPopover: {
            title: "Covid Check",
            certificateTitle: "Required documents",
            createAccount: "Permanent registration simplifies future visits, Tastier-wide",
            deleteAfterDays: "Data entry only for one-time / short-term use",
            signupBtn: "Sign Up + Enter Data",
            signInBtn: "Log In",
            onlyCoronaBtn: "Enter Data",
            firstName: "First name",
            lastName: "Last name",
            birthday: "Date of birth",
            phone: "Phone number",
            disclaimer: 'I confirm to have read, understood and accepted Tastier Ltd.\'s <a href="https://www.tastier.ch/terms-of-use-for-users/" target="_blank">Terms of Use</a> and <a href="https://www.tastier.ch/dataprivacy/" target="_blank">Privacy Policy</a>.',
            certDataProtection: '<a href="https://www.tastier.ch/dataprivacy/" target="_blank">Data protection</a> is important to us. Certificate is only checked for validity, not stored. No data transfer / use of the documents for other purposes.',
            certificateExpired: "This certificate is no longer valid. Please upload a new one.",
            failedBecauseInvalid: "This certificate is invalid or expired. Please upload a valid certificate.",
            failedToDecode: "Not a valid certificate. Possibly this type of certificate is not yet supported. Please contact the staff.",
            failedToReadQr: "Failed to read the certificate QR code. Please upload a better image.",
            failedUpload: "Upload of the certificate failed due to an unknown error. Please try again or notify the staff or Tastier.",
            failedInvalidMode: "Sorry, this certificate does not meet the requirements. Please upload another certificate.",
            failedIdDocUnkown: "ID card cannot be read. Please upload a good image of an official photo ID. Use as common a type of ID as possible.",
            failedIdDocInvalid: "This ID card does not match the certificate. Please upload a different ID card.",
            failedMissmatch: "The certificates do not match (date of birth or name).",
            failedDuplicate: "The second certificate has the same type or is identical to the first.",
            uploadCertName: "Vaccination / recovery certificate",
            uploadCertDesc: "Screenshot or photo of your Covid Certificate QR code",
            uploadSecondaryCertName: "Test certificate",
            uploadSecondaryCertDesc: "required if 2G certificate is older than 4 months",
            uploadIdName: "ID card",
            uploadIdDesc: "Screenshot or photo of an official photo ID card",
            verifyBtn: "Check (~10 s)",
            stateUploadingFiles: "Being uploaded...",
            stateValidatingCertificate: "Certificate being checked...",
            stateValidatingIdentity: "ID being checked...",
            stateDecryptAndStore: "Final steps...",
            submit: "Submit",
            back: "Go back",
            failed: "Data could not be saved",
            disablePrivate: "You are surfing in <b>PRIVATE / INCOGNITO MODE</b>. To avoid having to enter your data again next time, leave private mode and start over.",
        },
        minimumAgePopover: {
            title: "Age Check",
            text: "Are you at least {0} years old? Checks are possible.",
            confirm: "Yes",
            cancel: "No",
        },
        fulfillmentPopover: {
            title: "Confirmation",
            currentTime: "Current time",
            emptyGroup: "Without allocation",
            didYouGetEverything: "Did you receive everything?",
            didYouGetWholeOrder: "You hereby confirm receipt of the complete order. Did you receive everything?",
            showWhenPickingUpOrder: "Show this screen when picking up your order. Click the button when you received it.",
            yesGotIt: "Yes, received",
            readyForPickUp: "Ready for pick-up",
            xItemsInMyOrder: "{0}x item(s) in my order",
        },
        addToCartPopover: {
            price: "Price",
            optional: "Optional",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Select {0} {1}",
            chooseMin: "Select at least {0} {1}",
            chooseUpTo: "Optional. Select up to {0} {1}",
            chooseBetween: "Select {0} - {1} options",
            upToTotalItems: "In total up to {0} items",
            chooseOption: "Select your options",
            loadingOptions: "Options are being loaded...",
            failedLoadingOptions: "Options could not be loaded.",
            adding: "...",
        },
        signin: {
            title: "Login",
            email: "Email",
            password: "Password",
            resetPasswordTitle: "Password Reset",
            repeatPassword: "Repeat password",
            resetPassword: "Reset Password",
            setNewPassword: "Set New Password",
            reset: "Reset",
            loginWith: "Log in with",
            login: "Log In",
            signup: "Sign up",
            logout: "Log Out",
            backToLogin: "Back to login",
            checkYourInbox: 'We\'ve sent you an email to reset your password, please check your inbox and if necessary your spam folder. Please mark Tastier as safe sender or "Not Spam".',
            resetSuccess: "Your password has been successfully changed. You can now log in with it.",
            resetFailed: "This email does not exist on Tastier. Please check your input.",
            signinFailed: "Login failed. Please check your credentials. Or sign up instead to create a new account.",
            externalAuthFailed: "Login via Facebook / Google / LinkedIn failed. Please close the browser tab of this provider and try again.",
        },
        signup: {
            title: "Sign-Up",
            firstName: "First name",
            lastName: "Last name",
            phoneNumber: "Phone number",
            zip: "Postal code (of place of residence)",
            disclaimer: 'I confirm to have read, understood and accepted Tastier Ltd.\'s <a href="https://www.tastier.ch/terms-of-use-for-users/" target="_blank">Terms of Use</a> and <a href="https://www.tastier.ch/dataprivacy/" target="_blank">Privacy Policy.</a>. You may occasionally receive communication from Tastier, from which you can unsubscribe at any time.',
            submit: "Sign Up",
            signin: "Log in with existing account",
            signupWithMail: "Sign up by email",
            signupFailed: "Could not complete sign-up",
            emailConfirmSuccess: "Email successfully confirmed. Thank you!",
            emailConfirmFailed: "Could not confirm email",
            emailAlreadyUsed: "This email is already taken. Go to login.",
        },
        enterCode: {
            title: "Enter Code",
            codeVerificationFailed: "Invalid code",
            digitCode: "6-digit code",
            pasteCode: "Paste code from clipboard",
        },
        profile: {
            title: "Profile",
            emailConfirmed: "Confirmed",
            emailUnconfirmed: "Not confirmed",
            changePassword: "Change password",
            currentPassword: "Current password",
            newPassword: "New password",
            onlyImageFiles: "Please select an image or PDF file.",
            updateBtn: "Save",
            resendConfirmation: "Resend confirmation email",
            failedResend: "Could not send email. Please try again.",
            failedSave: "Could not save profile changes. Please try again.",
            profileSaved: "Profile successfully updated",
            confirmationSent: 'Email successfully sent. Please check your inbox and if necessary your spam folder. Please mark Tastier as safe sender or "Not Spam".',
        },
        creditCard: {
            title: "Payment Methods",
            failedRemove: "Could not delete payment method.",
            expired: "Expired",
            ccHolder: "Name on card",
            ccNumber: "Card number",
            ccExpiry: "Expiry date",
            ccCvc: "CVC",
            confirmDelete: "Do you want to permanently delete this payment method?",
            deleteBtn: "Remove",
        },
        orderHistory: {
            title: "Orders",
            confirmation: "Show confirmation",
            loadingOrders: "Orders are being loaded...",
            noOrders: "No orders available",
        },
        paymentHistory: {
            title: "Payments",
            noPayments: "No payments available",
            loadingPayments: "Payments are being loaded...",
        },
        receipt: {
            title: "Order",
            loading: "Order is being loaded...",
            sendReceipt: "Send Receipt",
            sendReceiptEmail: "Email address",
            receiptPrinted: "Print job sent",
            total: "Total",
            failedLoadingOrder: "Order could not be loaded.",
            failedSendReceipt: "Receipt could not be sent.",
            payment: "Payment",
            printReceipt: "Print Receipt",
            receipt: "Receipt",
        },
        help: {
            helpTitle: "Feedback",
            helpLead: "We look forward to hearing from you!",
            helpText: "Rate Tastier, give feedback, report a problem or ask a question. If it is urgent, please call us.<br /><br />Please address feedback regarding a venue's services (food, drinks, service, etc.) to the corresponding venue.",
            rateTastierBtn: "Rate Tastier",
            reportProblemBtn: "Report a problem / ask a question",
            issueTitle: "Tastier Support Request",
            rateTitle: "Tastier Rating",
            rateLead: "Tell us how you like Tastier!",
            rateText: "Your rating helps us to improve and develop Tastier. Scale: 1 star = Very bad, 5 stars = Great",
            rating: "Rating",
            reportProblem: "What's not working well? How and when does the error occur?",
            howImprove: "How can Tastier improve?",
            sendBtn: "Send",
            ratingSuccessful: "Rating sent. Thanks a lot!",
            reportIssueSuccessful: "Support request submitted. We will get back to you as soon as possible.",
            failedRate: "Could not send rating",
            failedReportIssue: "Could not send support request",
        },
        navigation: {
            profile: "Profile",
            leaveTable: "Leave",
            help: "Feedback",
            creditCards: "Payment Methods",
            reports: "Reports",
            orderHistory: "Orders",
            paymentHistory: "Payments",
            login: "Log In",
            signup: "Sign Up",
            logout: "Log Out",
            guest: "Guest",
            switchIdentity: "Continue Logging",
        },
        documents: {
            loading: "Loading...",
            failedToLoad: "Documents could not be loaded.",
            noData: "No documents are currently published.",
        },
        covid: {
            title: "COVID-19 | Tastier",
            letsgo: "Get Started",
            checkout: "Leave Location",
            clickBeforeYouGo: "Do not delete browser data / history to avoid having to enter your data again next time.",
            guestNumber: "Guest number",
            validatingCertificate: "is being validated...",
            welcome: "Welcome!",
        },
        bill: {
            title: "Pay",
            waitingForOrder: 'Bill is retrieved...<br />Nothing appearing? This shouldn\'t happen. Best is to click "Leave" in the upper right corner and try again, or contact Tastier, see "Help"',
            discount: "Discount",
            continue: "Continue",
            fullyPaidItems: "Fully Paid Items",
            paid: "Paid",
            exclTip: "excl. tip",
            clearSelection: "Clear selection",
            noOrderYet: "Everything is paid, thank you! ",
            fullyPaid: "Bill fully paid",
            allItems: "All unpaid items",
            selectedItems: "item(s) selected",
            selectAll: "Select everything",
        },
        messages: {
            unauthorizedPleaseRefresh: "Your session has expired. The page will reload, please try again.",
        },
        general: {
            pleaseSelect: "Please select",
            close: "Close",
            done: "Done",
            ok: "Ok",
            continue: "Continue",
            save: "Save",
            edit: "Edit",
            add: "Add",
            cancel: "Cancel",
            confirm: "Confirm",
            understood: "Understood",
            operationFailed: "The operation could not be performed.",
            optional: "optional",
            verify: "Verify",
            today: "Today",
            date: "Date",
            time: "Time",
            accept: "Accept",
            yes: "Yes",
            shortWeekDay: {
                Sunday: "Sun",
                Monday: "Mon",
                Tuesday: "Tue",
                Wednesday: "Wed",
                Thursday: "Thu",
                Friday: "Fri",
                Saturday: "Sat",
            },
            copied: "Copied!",
        },
        passwordStrength: {
            minLength: "At least 8 characters",
            upperCase: "At least 1 uppercase character",
            lowerCase: "At least 1 lowercase character",
            digit: "At least 1 digit",
        },
        enums: {
            cancellationMode: {
                Amount: "Custom amount",
                Positions: "Individual items",
                WholeOrder: "Entire order",
            },
            paymentMethodMode: {
                Online: "Online",
                Offline: "Offline",
            },
            serviceType: {
                Covid: "Covid Check",
                Documents: "Documents",
                Order: "Order",
                Ticketing: "Tickets",
                Website: "Website",
                Offer: "Offer",
                Pay: "Pay",
                RoomPlan: "Room Plan",
            },
        },
        preloadingSteps: {
            assets: "Loading images and assets...",
            domStructure: "Creating DOM structure...",
            identity: "Loading identity / connecting websocket...",
            paymentProvider: "Checking payment providers...",
        },
        addToHomeScreen: {
            title: "Sorry, Apple user! Follow the steps below to receive notifications. This will add Tastier to your Home Screen (will look like an app).",
            step1: "1. Click" + '<img class="shareicon" src="/assets/img/app/iphone-share.png" alt="the Share button" height="20" width="15">' + ', scroll down, "Add to Home Screen"' + '<img class="addtohomescreenicon" src="/assets/img/app/iphone-add-to-home-screen.png" alt="the Add to home screen button" height="20" width="20">' + '"Add"',
            step2: "2. Click the " + '<img class="shareicon" src="/assets/img/app/apple-touch-icon.png" alt="the Share button" height="22" width="22">' + " app icon on the Home Screen.",
            step3: "3. Close this browser tab.",
        },
        voucher: {
            invalidCode: "Invalid code",
            codeExpired: "Code expired",
            codeNotApplicable: "Code not applicable",
            codeUsed: "Code used up",
            voucherCodeAlreadyApplied: "Code already applied"
        },
        app: {
            title: "Tastier Mobile App",
        },
        paymentMethodsReport: {
            paymentMethodsReport: "Payment methods report",
            paymentMethod: "Payment method",
            netQuantity: "Number Net",
            grossSalesNetChfInclTip: "Gross sales Net CHF incl. tip",
            grossSalesPercent: "Gross sales %",
            cancellationQuantity: "Number of cancellations",
            quantity: "Number",
            grossSalesAvg: "Gross sales Ø CHF",
            tipNet: "Tip Net CHF",
            grossNetSales: "Gross sales Net CHF",
            dateRangeGenerated: "Generated <b>{0}</b><br>Start <b>{1}</b></br>End <b>{2}</b>",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "No payment method configured",
        },
        temporaryChange: (values) => {
            temporaryChangeTranslations(trans, Language.English, values);
        },
    };
};

const setGerman = () => {
    trans = {
        allocation: {
            headline: "Besser bedient",
            scanQrBtn: "QR-Code Scannen",
            scanHint: "Button klicken um zu beginnen",
            disclaimer: 'Mit der Nutzung von Tastiers Dienstleistungen bestätige ich, die <a href="https://www.tastier.ch/nutzungsbedingungen-fuer-nutzer/" target="_blank">Nutzungsbedingungen</a> und die <a href="https://www.tastier.ch/dataprivacy-de/" target="_blank">Datenschutzerklärung</a> der Tastier AG gelesen, verstanden und akzeptiert zu haben.',
            cameraFailed: "Kamera-Zugriff verweigert. Bitte erlaube Tastier in den Browser-Einstellungen Zugriff auf die Kamera (Website-Daten / -Einstellungen löschen) und versuche es erneut.",
            tableDoesNotExist: "Leider ist diese Nummer derzeit nicht aktiviert. Bitte korrigiere die Eingabe oder wende dich ans Personal oder Tastier.",
            locationSuspended: "Leider ist dieser Standort derzeit nicht aktiviert. Bitte wende dich ans Personal oder Tastier.",
            allocationFailed: "Leider ist das Einchecken fehlgeschlagen. Bitte lade die Seite neu und versuche es nochmals.",
            title: "Willkommen",
            enterCode: "6-stelligen Code Eingeben",
            or: "oder",
            doYouHaveOpenBill: "Du hast eine offene Bestellung / Rechnung?<br />Bitte tue nochmals was dich ursprünglich hierher geführt hat (z.B. den Link / Button anklicken, den QR-Code scannen).",
        },
        notification: {
            allow: "Ja",
            dontAllow: "Nein",
            notificationPermission: "Möchtest du eine Benachrichtigung erhalten, wenn deine Bestellung fertig ist? Sonst musst du deinen Browser häufig überprüfen, um deine Bestellung nicht zu verpassen.",
            notifiedWhenOrderReadyWithDuration: "Du wirst benachrichtigt, wenn deine Bestellung abholbereit ist. Voraussichtliche Wartezeit (Richtwert, kann sich jederzeit ändern):",
            notifiedWhenOrderReadyWithPosition: "Du wirst benachrichtigt, wenn deine Bestellung abholbereit ist. Aktuelle Position auf der Warteliste:",
            notificationsDenied: "Du hast Benachrichtigungen abgelehnt. Schliesse dieses Browser-Tab nicht und prüfe es regelmässig auf Aktualisierungen.",
            enableNotificationFailed: "Dein Browser / Gerät kann keine Benachrichtigungen empfangen. Schliesse dieses Browser-Tab nicht und prüfe es regelmässig auf Aktualisierungen.",
            checkIfPrivateMode: "Wir empfehlen, beim nächsten Mal nicht den privaten / Inkognito-Modus zu verwenden.",
            onMyWay: "Abholbildschirm Anzeigen",
            pickUpOrderTitle: "Bestellung abholen",
            orderReadyToPickUp: "Deine Bestellung ist abholbereit",
            orderScheduled: "Deine Bestellung ist bald abholbereit",
            browserNotSupportNotifications: "Dein Browser / Apple Gerät kann keine Benachrichtigungen empfangen. Schliesse dieses Browser-Tab nicht und prüfe es regelmässig auf Aktualisierungen.",
        },
        order: {
            title: "Bestellen",
            loadingOffer: "Angebot wird geladen...",
            itemsSelected: "{0} Artikel ausgewählt",
            noOffer: "Leider ist zurzeit kein Angebot verfügbar.",
            cancellationSuccessful: "Stornierung erfolgreich",
            cancel: "Stornieren"
        },
        cart: {
            title: "Warenkorb",
            itemsSelected: "{0} Artikel",
            failedToAdd: "Artikel konnte nicht hinzugefügt werden.",
            failedToRemove: "Artikel konnte nicht entfernt werden.",
            failedToChange: "Artikel konnte nicht modifiziert werden.",
            paymentBlockingCart: "Der Warenkorb kann nicht angepasst werden während eine Zahlung in Bearbeitung ist.",
            minimumChf: "mind. {0}",
            noItems: "Dem Warenkorb wurden noch keine Artikel hinzugefügt.",
            backToOverview: "Zur Angebotsübersicht",
            haveItemsInCart: "Du hast Artikel in deinem {0} Warenkorb. Wenn du fortfährst, wird dein Warenkorb gelöscht.",
        },
        print: {
            orderReceiptPrinted: "Druckauftrag gesendet",
            failedPrintReceipt: "Druckauftrag fehlgeschlagen",
            noProductionSiteEnabledForRoom: "Diesem Tisch / Raum ist kein aktivierter Quittungsdrucker zugewiesen.",
            printReceipt: "Quittung Drucken",
        },
        pay: {
            title: "Zahlung",
            discount: "Rabatt",
            total: "Total",
            paying: "Zahlen...",
            disclaimer: 'Es gelten: Tastier <a href="https://www.tastier.ch/nutzungsbedingungen-fuer-nutzer/" target="_blank">AGB</a> & <a href="https://www.tastier.ch/dataprivacy-de/" target="_blank">Datenschutz</a>, Anbieter AGB.',
            contactingAquirer: "Bitte warten...",
            signup: "Registrieren",
            signupBenefits: "Optional. Vorteile: Zahlungsmittel speichern, Quittungen automatisch per E-Mail, Bestellhistorie",
            btnFailed: "Fehlgeschlagen",
            btnSuccessful: "Erfolgreich",
            preparingCardForm: "Formular wird geladen...",
            failedAuthorization: "Zahlungsmittel konnte nicht belastet werden.",
            failedCartIsOutdated: "Du hast versucht einen veralteten Warenkorb zu bezahlen, bitte aktualisiere die Webseite.",
            failedCartIsEmpty: "Du versuchst einen leeren Warenkorb zu bezahlen.",
            failedOfferExpired: "Mindestens ein Artikel in deinem Warenkorb ist nicht mehr verfügbar.",
            failedOrderIsClosed: "Die Bestellung ist bereits vollständig bezahlt.",
            orderWithStaff: "Bestelle beim Personal",
            order: "Bestellen",
            ordering: "Bestellen...",
            provideEmailMessage: "Bitte E-Mail eingeben oder dich registrieren",
        },
        done: {
            fullyPaid: "Rechnung vollständig bezahlt",
            startOver: "Weiter",
            signupAndReceipt: "Quittung Erhalten & Registrieren",
            getReceipt: "Quittung Erhalten",
            disclaimer: "Du erhältst möglicherweise gelegentlich Kommunikation von Tastier, wovon du dich jederzeit abmelden kannst.",
            signupAndReceiptBtn: "Registrieren & Quittung Schicken",
            weSentReceipt: "Wir haben deine Quittung geschickt an",
            weSentConfirmation: "Wir haben deine Bestätigung geschickt an",
            failedSignup: "Registrierung fehlgeschlagen. Bitte versuche es erneut.",
            onlyReceipt: "Nur Quittung erhalten",
            signupHintTitle: "Quittung per E-Mail",
            signupHintText: "Gib deine E-Mail ein, um eine Quittung zu erhalten. Und setze ein Passwort, um mit einem Tastier Zugang nächstes Mal noch einfacher zu zahlen (ohne das Zahlungsmittel einzugeben) und um Tastier Quittungen automatisch zugeschickt zu bekommen.",
            trxCheckingTitle: "Zahlung in Bearbeitung",
            trxCheckingText: "Bitte warten...",
            trxSuccessTitle: "Zahlung erfolgreich",
            trxDeclinedTitle: "Zahlung fehlgeschlagen",
            trxDeclinedText: "Bitte nochmals versuchen",
            trxFailedCheckingTitle: "Zahlung nicht bestätigt",
            trxFailedCheckingText: "Zeitlimit überschritten",
            backToOrder: "Neue Bestellung Tätigen",
            backToPayment: "Neue Zahlung tätigen",
            displayOrderBtn: "Bestellung Anzeigen",
            displayPaymentBtn: "Zahlung Anzeigen",
            title: "Quittung & Mehr",
            more: "Mehr",
            displayOrderHeadline: "Meine Bestellung",
            displayPaymentHeadline: "Meine Zahlung",
            signup: "Registrieren",
            unpaid: "Unbezahlt",
        },
        cancelOrderPopover: {
            cancellationFailed: "Bestellung konnte nicht storniert werden.",
            title: "Stornierung",
            offlineMode: "Offline Rückerstattung",
            wholeOrderText: "Die gesamte Bestellung wird storniert werden.",
            yesCancel: "Ja, stornieren",
        },
        orderReceivedPopover: {
            plannedPickUpTime: "Geplante Abholzeit",
            received: "Bestellung Empfangen",
            hint: 'Auf deiner Abrechnung wird "Tastier" erscheinen',
            receiptAndMore: "Quittung & Mehr",
            more: "Mehr",
            copyAddress: "Adresse Kopieren",
            googleMapsLocation: "Google Maps Standort",
        },
        paymentReceivedPopover: {
            received: "Zahlung erhalten",
            unpaid: "Unbezahlt",
            more: "Mehr",
            fullyPaid: "Rechnung vollständig bezahlt",
        },
        tableSelectionPopover: {
            title: "Tischauswahl",
            tableNumber: "Tischnummer",
            welcomeTo: "Willkommen im",
            hint: "Bitte frage den Kellner nach deiner Tischnummer, wenn diese nicht abgebildet ist oder falls es Probleme gibt.",
        },
        tableInfoPopover: {
            title: "Wohin soll es gehen?",
            textFieldLbl: "Genauer Zielort (Person / Tisch / Bereich)",
            hint: "Bitte gib deinen genauen Zielort ein, sodass später klar und unmissverständlich nachvollzogen werden kann wo du dich aufgehalten hast.",
        },
        phoneNumberPopover: {
            title: "Datenvervollständigung",
            phoneNumber: "Telefonnummer",
            disclaimer: "Bitte vervollständige diese Angaben",
            submitBtn: "Speichern",
            failed: "Daten konnten nicht gespeichert werden.",
        },
        covidSignupPopover: {
            title: "Covid-Check",
            certificateTitle: "Erforderliche Dokumente",
            createAccount: "Dauerhafte Registrierung vereinfacht zukünftige Besuche, Tastier-weit",
            deleteAfterDays: "Dateneingabe nur für einmalige / kurzfristige Nutzung",
            signupBtn: "Registrieren + Daten Eingeben",
            signInBtn: "Einloggen",
            onlyCoronaBtn: "Daten Eingeben",
            firstName: "Vorname",
            lastName: "Nachname",
            birthday: "Geburtsdatum",
            phone: "Telefonnummer",
            disclaimer: 'Ich bestätige die <a href="https://www.tastier.ch/nutzungsbedingungen-fuer-nutzer/" target="_blank">Nutzungsbedingungen</a> und die <a href="https://www.tastier.ch/dataprivacy-de/" target="_blank">Datenschutzerklärung</a> der Tastier AG gelesen, verstanden und akzeptiert zu haben.',
            certDataProtection: ' <a href="https://www.tastier.ch/dataprivacy-de/" target="_blank">Datenschutz</a> ist uns wichtig. Zertifikat wird nur auf Gültigkeit überprüft, nicht gespeichert. Keine Datenweitergabe / zweckfremde Nutzung der Dokumente.',
            certificateExpired: "Dieses Zertifikat ist nicht mehr gültig. Bitte lade ein neues hoch.",
            failedBecauseInvalid: "Dieses Zertifikat ist ungültig oder abgelaufen. Bitte lade ein gültiges Zertifikat hoch.",
            failedToDecode: "Kein gültiges Zertifikat. Möglicherweise wird dieser Zertifikatstyp noch nicht unterstützt. Bitte wende dich ans Personal.",
            failedToReadQr: "Einlesen des Zertifikats-QR-Codes fehlgeschlagen. Bitte lade eine bessere Abbildung hoch.",
            failedUpload: "Hochladen des Zertifikats aufgrund eines unbekannten Fehlers fehlgeschlagen. Bitte versuche es erneut oder benachrichtige das Personal oder Tastier.",
            failedInvalidMode: "Dieses Zertifikat erfüllt leider nicht die Anforderungen. Bitte lade ein anderes Zertifikat hoch.",
            failedIdDocUnkown: "Ausweis kann nicht gelesen werden. Bitte lade eine gute Abbildung eines offiziellen Lichtbildausweises hoch. Nutze eine möglichst gängige Ausweisart.",
            failedIdDocInvalid: "Dieser Ausweis stimmt nicht mit dem Zertifikat überein. Bitte lade einen anderen Ausweis hoch.",
            failedMissmatch: "Die Zertifikate stimmen nicht überein (Geburtsdatum oder Name).",
            failedDuplicate: "Das zweite Zertifikat hat denselben Typ oder ist identisch zum ersten.",
            uploadCertName: "Impf- / Genesen-Zertifikat",
            uploadCertDesc: "Screenshot oder Foto deines Covid-Zertifikat-QR-Codes",
            uploadSecondaryCertName: "Test-Zertifikat",
            uploadSecondaryCertDesc: "benötigt wenn 2G-Zertifikat älter als 4 Monate ist",
            uploadIdName: "Ausweis",
            uploadIdDesc: "Screenshot oder Foto eines offiziellen Foto-Ausweises",
            verifyBtn: "Überprüfen (~10 s)",
            stateUploadingFiles: "Werden hochgeladen...",
            stateValidatingCertificate: "Zertifikat wird geprüft...",
            stateValidatingIdentity: "Ausweis wird geprüft...",
            stateDecryptAndStore: "Letzte Schritte...",
            submit: "Abschicken",
            back: "Zurück gehen",
            failed: "Daten konnten nicht gespeichert werden.",
            disablePrivate: "Du surfst im <b>PRIVATEN / INKOGNITO MODUS</b>. Damit du nächstes Mal deine Daten nicht nochmals eingeben musst, verlasse den privaten Modus und beginne nochmals.",
        },
        minimumAgePopover: {
            title: "Alterskontrolle",
            text: "Bist du mindestens {0} Jahre alt? Kontrollen sind möglich.",
            confirm: "Ja",
            cancel: "Nein",
        },
        fulfillmentPopover: {
            title: "Bestätigung",
            currentTime: "Aktuelle Uhrzeit",
            emptyGroup: "Ohne Zuteilung",
            didYouGetEverything: "Hast du alles erhalten?",
            didYouGetWholeOrder: "Hiermit bestätigst du den Empfang der kompletten Bestellung. Hast du alles erhalten?",
            showWhenPickingUpOrder: "Zeige diesen Bildschirm, wenn du deine Bestellung abholst. Klicke den Button, wenn du sie erhalten hast.",
            yesGotIt: "Ja, erhalten",
            readyForPickUp: "Abholbereit",
            xItemsInMyOrder: "{0}x Artikel in meiner Bestellung",
        },
        addToCartPopover: {
            price: "Preis",
            optional: "Optional",
            optionSing: "Option",
            optionPlur: "Optionen",
            chooseExact: "Wähle {0} {1} aus",
            chooseMin: "Wähle mind. {0} {1} aus",
            chooseUpTo: "Optional. Wähle bis zu {0} {1} aus",
            chooseBetween: "Wähle {0} - {1} Optionen aus",
            upToTotalItems: "Insg. bis zu {0} Artikel",
            chooseOption: "Wähle deine Optionen",
            loadingOptions: "Optionen werden geladen...",
            failedLoadingOptions: "Optionen konnten nicht geladen werden.",
            adding: "...",
        },
        signin: {
            title: "Login",
            email: "E-Mail",
            password: "Passwort",
            resetPasswordTitle: "Passwort-Zurücksetzung",
            repeatPassword: "Password wiederholen",
            resetPassword: "Passwort Zurücksetzen",
            setNewPassword: "Neues Passwort Setzen",
            reset: "Zurücksetzen",
            loginWith: "Einloggen mit",
            login: "Einloggen",
            signup: "Registrieren",
            logout: "Ausloggen",
            backToLogin: "Zurück zum Login",
            checkYourInbox: 'E-Mail erfolgreich verschickt. Bitte überprüfe deinen Posteingang und ggf. deinen Spam Ordner. Bitte markiere Tastier als sicheren Absender bzw. "Kein Spam".',
            resetSuccess: "Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt damit einloggen.",
            resetFailed: "Diese E-Mail existiert bei Tastier nicht. Bitte überprüfe deine Eingabe.",
            signinFailed: "Login fehlgeschlagen. Bitte überprüfe deine Zugangsdaten. Oder registriere dich stattdessen, um einen neuen Zugang zu erstellen.",
            externalAuthFailed: "Login über Facebook / Google / LinkedIn fehlgeschlagen. Bitte schliesse den Browser Tab dieses Anbieters und versuche es erneut.",
        },
        signup: {
            title: "Registrierung",
            firstName: "Vorname",
            lastName: "Nachname",
            phoneNumber: "Telefonnummer",
            zip: "Postleitzahl (des Wohnorts)",
            disclaimer: 'Ich bestätige die <a href="https://www.tastier.ch/nutzungsbedingungen-fuer-nutzer/" target="_blank">Nutzungsbedingungen</a> und die <a href="https://www.tastier.ch/dataprivacy-de/" target="_blank">Datenschutzerklärung</a> der Tastier AG gelesen, verstanden und akzeptiert zu haben. Du erhältst möglicherweise gelegentlich Kommunikation von Tastier, wovon du dich jederzeit abmelden kannst.',
            submit: "Registrieren",
            signin: "Mit bestehendem Zugang einloggen",
            signupWithMail: "Per E-Mail registrieren",
            signupFailed: "Registrierung konnte nicht abgeschlossen werden.",
            emailConfirmSuccess: "E-Mail erfolgreich bestätigt. Vielen Dank!",
            emailConfirmFailed: "E-Mail konnte nicht bestätigt werden.",
            emailAlreadyUsed: "Diese E-Mail ist bereits vergeben. Gehe zum Login.",
        },
        enterCode: {
            title: "Code Eingeben",
            codeVerificationFailed: "Ungültiger Code",
            digitCode: "6-stelliger Code",
            pasteCode: "Code aus Zwischenablage einfügen",
        },
        profile: {
            title: "Profil",
            emailConfirmed: "Bestätigt",
            emailUnconfirmed: "Nicht bestätigt",
            changePassword: "Passwort ändern",
            currentPassword: "Aktuelles Passwort",
            newPassword: "Neues Passwort",
            onlyImageFiles: "Bitte wähle eine Bild- oder PDF-Datei aus.",
            updateBtn: "Speichern",
            resendConfirmation: "Bestätigungs-E-Mail erneut senden",
            failedResend: "E-Mail konnte nicht verschickt werden. Bitte versuche es erneut.",
            failedSave: "Profiländerungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
            profileSaved: "Profil erfolgreich aktualisiert",
            confirmationSent: 'E-Mail erfolgreich verschickt. Bitte überprüfe deinen Posteingang und ggf. deinen Spam Ordner. Bitte markiere Tastier als sicheren Absender bzw. "Kein Spam".',
        },
        creditCard: {
            title: "Zahlungsmittel",
            failedRemove: "Zahlungsmittel konnte nicht gelöscht werden.",
            expired: "Abgelaufen",
            ccHolder: "Name auf der Karte",
            ccNumber: "Kartennummer",
            ccExpiry: "Ablaufdatum",
            ccCvc: "CVC",
            confirmDelete: "Willst du dieses Zahlungsmittel permanent löschen?",
            deleteBtn: "Löschen",
        },
        orderHistory: {
            title: "Bestellungen",
            confirmation: "Bestätigung anzeigen",
            loadingOrders: "Bestellungen werden geladen...",
            noOrders: "Keine Bestellungen vorhanden",
        },
        paymentHistory: {
            title: "Zahlungen",
            noPayments: "Keine Zahlungen vorhanden",
            loadingPayments: "Zahlungen werden geladen...",
        },
        receipt: {
            title: "Bestellung",
            loading: "Bestellung wird geladen...",
            sendReceipt: "Quittung Schicken",
            sendReceiptEmail: "E-Mail-Adresse",

            receiptPrinted: "Druckauftrag gesendet",
            total: "Total",
            failedLoadingOrder: "Bestellung konnte nicht geladen werden.",
            failedSendReceipt: "Druckauftrag fehlgeschlagen",
            payment: "Zahlung",
            printReceipt: "Quittung Drucken",
            receipt: "Quittung",
        },
        help: {
            helpTitle: "Feedback",
            helpLead: "Wir freuen uns von dir zu hören!",
            helpText: "Bewerte Tastier, gib Feedback, melde ein Problem oder stelle eine Frage. Wenn es dringend ist, melde dich bitte telefonisch.<br /><br />Bitte richte Feedback betreffend der Dienstleistungen eines Betriebs (Essen, Trinken, Service, usw.) an den jeweiligen Betreiber.",
            rateTastierBtn: "Tastier bewerten",
            reportProblemBtn: "Problem melden / Frage stellen",
            issueTitle: "Tastier Supportanfrage",
            rateTitle: "Tastier Bewertung",
            rateLead: "Sag uns, wie dir Tastier gefällt!",
            rateText: "Deine Bewertung hilft uns Tastier zu verbessern und weiterzuentwickeln. Skala: 1 Stern = Sehr schlecht, 5 Sterne = Super",
            rating: "Bewertung",
            howImprove: "Wie kann Tastier besser werden?",
            reportProblem: "Was funktioniert nicht gut? Wie und wann tritt der Fehler auf?",
            sendBtn: "Abschicken",
            ratingSuccessful: "Bewertung abgeschickt. Vielen Dank!",
            reportIssueSuccessful: "Supportanfrage eingereicht. Wir werden uns so bald wie möglich bei dir melden.",
            failedRate: "Bewertung konnte nicht abgeschickt werden.",
            failedReportIssue: "Supportanfrage konnte nicht abgeschickt werden.",
        },
        navigation: {
            profile: "Profil",
            leaveTable: "Verlassen",
            help: "Feedback",
            creditCards: "Zahlungsmittel",
            reports: "Berichte",
            orderHistory: "Bestellungen",
            paymentHistory: "Zahlungen",
            login: "Einloggen",
            signup: "Registrieren",
            logout: "Ausloggen",
            guest: "Gast",
            switchIdentity: "Weiter Erfassen",
        },
        documents: {
            loading: "Wird geladen...",
            failedToLoad: "Dokumente konnten nicht geladen werden.",
            noData: "Aktuell sind keine Dokumente publiziert.",
        },
        covid: {
            title: "COVID-19 | Tastier",
            letsgo: "Los Geht's",
            checkout: "Standort Verlassen",
            clickBeforeYouGo: "Browserdaten / Verlauf nicht löschen, damit du nächstes Mal deine Daten nicht nochmals eingeben musst.",
            guestNumber: "Gastzahl",
            validatingCertificate: "wird validiert...",
            welcome: "Willkommen!",
        },
        bill: {
            title: "Bezahlen",
            waitingForOrder: 'Rechnung wird aufgerufen...<br />Nichts erscheint? Das sollte nicht passieren. Am besten rechts oben «Verlassen» klicken und nochmals versuchen, oder Tastier kontaktieren, siehe "Feedback"',
            discount: "Rabatt",
            continue: "Weiter",
            fullyPaidItems: "Vollständig Bezahlte Artikel",
            paid: "Gezahlt",
            exclTip: "exkl. Trinkgeld",
            clearSelection: "Auswahl aufheben",
            noOrderYet: "Alles ist bezahlt, danke!",
            fullyPaid: "Rechnung vollständig Bezahlt",
            allItems: "Alle unbezahlten Artikel",
            selectedItems: "Artikel ausgewählt",
            selectAll: "Alles auswählen",
        },
        messages: {
            unauthorizedPleaseRefresh: "Deine Sitzung ist abgelaufen. Die Seite wird neu geladen, bitte versuche es nochmals.",
        },
        general: {
            pleaseSelect: "Bitte auswählen",
            close: "Schliessen",
            done: "Fertig",
            continue: "Weiter",
            ok: "Ok",
            edit: "Bearbeiten",
            save: "Speichern",
            add: "Hinzufügen",
            cancel: "Abbrechen",
            confirm: "Bestätigen",
            understood: "Verstanden",
            operationFailed: "Der Vorgang konnte nicht ausgeführt werden.",
            optional: "optional",
            verify: "Überprüfen",
            today: "Heute",
            date: "Datum",
            time: "Uhrzeit",
            accept: "Akzeptieren",
            yes: "Ja",
            shortWeekDay: {
                Sunday: "Son",
                Monday: "Mon",
                Tuesday: "Die",
                Wednesday: "Mit",
                Thursday: "Don",
                Friday: "Fre",
                Saturday: "Sam",
            },
            copied: "Kopiert!",
        },
        passwordStrength: {
            minLength: "Mindestens 8 Zeichen",
            upperCase: "Mindestens 1 Grossbuchstabe",
            lowerCase: "Mindestens 1 Kleinbuchstabe",
            digit: "Mindestens 1 Zahl",
        },
        enums: {
            cancellationMode: {
                Amount: "Manueller Betrag",
                Positions: "Einzelpositionen",
                WholeOrder: "Gesamte Bestellung",
            },
            paymentMethodMode: {
                Online: "Online",
                Offline: "Offline",
            },
            serviceType: {
                Covid: "Covid-Check",
                Documents: "Dokumente",
                Order: "Bestellen",
                Ticketing: "Tickets",
                Website: "Webseite",
                Offer: "Angebot",
                Pay: "Bezahlen",
                RoomPlan: "Raumplan",
            },
        },
        preloadingSteps: {
            assets: "Bilder / Assets werden geladen...",
            domStructure: "Dom Struktur wird aufgebaut...",
            identity: "Identität und Websockets werden geladen...",
            paymentProvider: "Zahlungsanbieter werden geprüft...",
        },
        voucher: {
            invalidCode: "Ungültiger Code",
            codeExpired: "Code abgelaufen",
            codeNotApplicable: "Code nicht anwendbar",
            codeUsed: "Code aufgebraucht",
            voucherCodeAlreadyApplied: "Code bereits angewendet"
        },
        addToHomeScreen: {
            title: "Sorry, Apple-Nutzer! Führe die folgenden Schritte aus, um Benachrichtigungen zu erhalten. Dadurch wird Tastier zu deinem Homescreen hinzugefügt (sieht aus wie eine App).",
            step1: "1. Klicke" + '<img class="shareicon" src="/assets/img/app/iphone-share.png" alt="the Share button" height="20" width="15">' + ', scrolle runter, "Zum Home-Bildschirm"' + '<img class="addtohomescreenicon" src="/assets/img/app/iphone-add-to-home-screen.png" alt="the Add to home screen button" height="20" width="19">' + '"Hinzufügen"',
            step2: "2. Klicke das " + '<img class="shareicon" src="/assets/img/app/apple-touch-icon.png" alt="the Share button" height="22" width="22">' + " App-Symbol auf dem Homescreen.",
            step3: "3. Schliesse dieses Browser-Tab.",
        },
        app: {
            title: "Tastier Mobile App",
        },
        paymentMethodsReport: {
            paymentMethodsReport: "Zahlungsmittelbericht",
            paymentMethod: "Zahlungsmittel",
            netQuantity: "Anzahl Netto",
            grossSalesNetChfInclTip: "Bruttoumsatz Netto CHF inkl. Trinkgeld",
            grossSalesPercent: "Bruttoumsatz %",
            cancellationQuantity: "Anzahl Storno",
            quantity: "Anzahl",
            grossSalesAvg: "Bruttoumsatz Ø CHF",
            tipNet: "Trinkgeld Netto CHF",
            grossNetSales: "Bruttoumsatz Netto CHF",
            dateRangeGenerated: "Erzeugt <b>{0}</b></br>Beginn <b>{1}</b></br>Ende <b>{2}</b>",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Kein Zahlungsmittel konfiguriert",
        },
        temporaryChange: (values) => {
            temporaryChangeTranslations(trans, Language.German, values);
        },
    };
};

const setFrench = () => {
    trans = {
        allocation: {
            headline: "Mieux servi",
            scanQrBtn: "Scanner le QR Code",
            scanHint: "Cliquer sur le bouton pour commencer",
            disclaimer: 'Avec l\'utilisation des services de Tastier je confirme avoir lu, compris et accepté les <a href="https://www.tastier.ch/conditions-dutilisation-pour-les-utilisateurs/" target="_blank">CU</a> et la <a href="https://www.tastier.ch/dataprivacy-fr/" target="_blank">politique de confidentialité</a> de Tastier SA.',
            cameraFailed: "Accès à l'appareil photo refusé. Merci de autoriser Tastier à accéder à l'appareil photo dans les paramètres du navigateur (supprimer les données / paramètres du site web) et réessayer.",
            tableDoesNotExist: "Malheureusement, ce numéro n'est pas actuellement activé. Merci de le corriger ou de s'adresser au personnel ou à Tastier.",
            locationSuspended: "Malheureusement, ce site n'est pas actuellement activé. Merci de contacter le personnel ou Tastier.",
            allocationFailed: "Malheureusement, l'enregistrement a échoué. Merci de recharger la page et d'essayer à nouveau.",
            title: "Bienvenue",
            enterCode: "Saisir le Code à 6 Chiffres",
            or: "ou",
            doYouHaveOpenBill: "Tu as une commande / note ouverte ?<br />S'il te plaît, refais ce qui t'a amené ici à l'origine (p. ex. cliquer sur le lien / bouton, scanner le QR code).",
        },
        notification: {
            allow: "Oui",
            dontAllow: "Non",
            notificationPermission: "Souhaites-tu recevoir une notification lorsque ta commande est prête ? Sinon, tu devras consulter fréquemment l'onglet pour ne pas rater ta commande.",
            notifiedWhenOrderReadyWithDuration: "Tu seras prévenu lorsque ta commande sera prête à être récupérée. Temps d'attente prévu (indicatif, peut changer à tout moment) :",
            notifiedWhenOrderReadyWithPosition: "Tu seras prévenu lorsque ta commande sera prête à être récupérée. Position actuelle sur la liste d'attente :",
            notificationsDenied: "Tu as refusé les notifications. Ne ferme pas cet onglet et vérifie fréquemment s'il y a des actualisations.",
            enableNotificationFailed: "Ton navigateur / appareil ne peut pas recevoir de notifications. Ne ferme pas cet onglet et vérifie fréquemment s'il y a des actualisations.",
            checkIfPrivateMode: "La prochaine fois, nous te recommandons de ne pas utiliser le mode privé / incognito.",
            onMyWay: "Afficher l'Écran Pick-Up",
            pickUpOrderTitle: "Retirer la commande",
            orderReadyToPickUp: "Ta commande est prête à être retirée",
            orderScheduled: "Ta commande sera bientôt prête à être retirée",
            browserNotSupportNotifications: "Ton navigateur / appareil Apple ne peut pas recevoir de notifications. Ne ferme pas cet onglet et vérifie fréquemment s'il y a des actualisations.",
        },
        order: {
            title: "Commander",
            loadingOffer: "Offre en cours de chargement...",
            itemsSelected: "{0} article(s) sélectionné(s)",
            noOffer: "Malheureusement, il n'y a pas d'offre disponible pour le moment.",
            cancellationSuccessful: "Annulation réussie",
            cancel: "Annuler"
        },
        cart: {
            title: "Panier",
            itemsSelected: "{0} article(s)",
            failedToAdd: "L'article n'a pas pu être ajouté.",
            failedToRemove: "L'article n'a pas pu être supprimé.",
            failedToChange: "L'article n'a pas pu être modifié.",
            paymentBlockingCart: "Le panier ne peut pas être modifié pendant qu'un paiement est en cours.",
            minimumChf: "au moins {0}",
            noItems: "Aucun article n'a encore été ajouté au panier.",
            backToOverview: "Vers l'aperçu de l'offre",
            haveItemsInCart: "Tu as des articles dans ton panier {0}. Si tu continues, ton panier sera supprimé.",
        },
        print: {
            orderReceiptPrinted: "Travail d'impression envoyé",
            failedPrintReceipt: "Travail d'impression échoué",
            noProductionSiteEnabledForRoom: "Aucune imprimante de reçus activée n'est attribuée à cette table / salle.",
            printReceipt: "Imprimer le Reçu",
        },
        pay: {
            title: "Paiement",
            discount: "Remise",
            total: "Total",
            paying: "En payant...",
            disclaimer: 'S\'applique : Tastier <a href="https://www.tastier.ch/conditions-dutilisation-pour-les-utilisateurs/" target="_blank">CU</a> & <a href="https://www.tastier.ch/dataprivacy-fr/" target="_blank">confidentialité</a>, CG du fournisseur.',
            contactingAquirer: "Patiente...",
            signup: "S'Inscrire",
            signupBenefits: "Optionnel. Avantages : Enregistrer les moyens de paiement, reçus automatiquement par e-mail, historique des commandes",
            btnFailed: "Échoué",
            btnSuccessful: "Succès",
            preparingCardForm: "Formulaire en cours de chargement...",
            failedAuthorization: "Le moyen de paiement n'a pas pu être débité.",
            failedCartIsOutdated: "Tu as essayé de payer avec un panier périmé, merci de rafraîchir le site.",
            failedCartIsEmpty: "Tu essaies de payer un panier vide.",
            failedOfferExpired: "Au moins un article de ton panier n'est plus disponible.",
            failedOrderIsClosed: "La commande est déjà payée en totalité.",
            orderWithStaff: "Commander auprès du personnel",
            order: "Commander",
            ordering: "Commander...",
            provideEmailMessage: "Merci de saisir ton adresse e-mail ou de t'inscrire",
        },
        done: {
            fullyPaid: "Addition payée entièrement",
            startOver: "Continuer",
            signupAndReceipt: "Recevoir le Reçu & S'Inscrire",
            getReceipt: "Recevoir le Reçu",
            disclaimer: "Il est possible que tu reçoives à l'occasion des communications de Tastier, dont tu peux te désabonner à tout moment.",
            signupAndReceiptBtn: "S'Inscrire & Envoyer le Reçu",
            weSentReceipt: "Nous avons envoyé ton reçu à",
            weSentConfirmation: "Nous avons envoyé ton confirmation à",
            failedSignup: "Échec de l'inscription. Merci de réessayer.",
            onlyReceipt: "Ne recevoir que le reçu",
            signupHintTitle: "Reçu par e-mail",
            signupHintText: "Saisis ton email pour recevoir un reçu. Et définis un mot de passe pour qu'il soit encore plus facile de payer avec un compte Tastier la prochaine fois (sans avoir à saisir ton mode de paiement) et pour que les reçus Tastier te soient envoyés automatiquement.",
            trxCheckingTitle: "Paiement en cours",
            trxCheckingText: "Merci de patienter...",
            trxSuccessTitle: "Paiement réussi",
            trxDeclinedTitle: "Paiement échoué",
            trxDeclinedText: "Merci de réessayer",
            trxFailedCheckingTitle: "Paiement non confirmé",
            trxFailedCheckingText: "La limite de temps est dépassée",
            backToOrder: "Passer une Nouvelle Commande",
            backToPayment: "Effectuer un nouveau paiement",
            displayOrderBtn: "Afficher la Commande",
            displayPaymentBtn: "Afficher le Paiement",
            title: "Reçu & Plus",
            more: "Plus",
            displayOrderHeadline: "Ma Commande",
            displayPaymentHeadline: "Mon Paiement",
            signup: "S'Inscrire",
            unpaid: "Non payé",
        },
        cancelOrderPopover: {
            cancellationFailed: "La commande n'a pas pu être annulée.",
            title: "Annulation",
            offlineMode: "Remboursement hors ligne",
            wholeOrderText: "La commande entière sera annulée.",
            yesCancel: "Oui, annuler",
        },
        orderReceivedPopover: {
            plannedPickUpTime: "Heure de retrait prévue ",
            received: "Commande Reçue",
            hint: '"Tastier" apparaîtra sur ton relevé bancaire',
            receiptAndMore: "Reçu & Plus",
            more: "Plus",
            copyAddress: "Copier l’Adresse",
            googleMapsLocation: "Localisation sur Google Maps”",
        },
        paymentReceivedPopover: {
            received: "Paiement reçu",
            unpaid: "Non payé",
            more: "Plus",
            fullyPaid: "Addition payée entièrement",
        },
        tableSelectionPopover: {
            title: "Choix de Table",
            tableNumber: "Numéro de table",
            welcomeTo: "Bienvenue chez",
            hint: "Merci de demander au serveur ton numéro de table si celui-ci ne s'affiche pas ou en cas de problème.",
        },
        tableInfoPopover: {
            title: "Où veux-tu aller ?",
            textFieldLbl: "Destination exacte (personne / table / zone)",
            hint: "Merci d'indiquer ta destination exacte, afin que l'on puisse plus tard déterminer clairement et sans équivoque où tu as été.",
        },
        phoneNumberPopover: {
            title: "Compléter les Données",
            phoneNumber: "Numéro de téléphone",
            disclaimer: "Merci de compléter ces informations",
            submitBtn: "Sauvegarder",
            failed: "Les données n'ont pas pu être sauvegardées.",
        },
        covidSignupPopover: {
            title: "Vérification Covid",
            certificateTitle: "Documents requis",
            createAccount: "L'inscription permanente simplifie les visites futures, à l'ensemble de Tastier",
            deleteAfterDays: "Saisie de données uniquement pour une utilisation unique / à court terme",
            signupBtn: "S'Inscrire + Entrer les Données",
            signInBtn: "Se Connecter",
            onlyCoronaBtn: "Entrer les Données",
            firstName: "Prénom",
            lastName: "Nom",
            birthday: "Date de naissance",
            phone: "Numéro de téléphone",
            disclaimer: 'Je confirme avoir lu, compris et accepté les <a href="https://www.tastier.ch/conditions-dutilisation-pour-les-utilisateurs/" target="_blank">CU</a> et la <a href="https://www.tastier.ch/dataprivacy-fr/" target="_blank">politique de confidentialité</a> de Tastier SA.',
            certDataProtection: 'La <a href="https://www.tastier.ch/dataprivacy-fr/" target="_blank">protection des données</a> est importante pour nous. Le certificat est seulement validé, il n\'est pas stocké. Aucun transfert de données / utilisation des documents à d\'autres fins.',
            certificateExpired: "Ce certificat n'est plus valable.Merci d'en télécharger un nouveau.",
            failedBecauseInvalid: "Ce certificat n'est pas valide ou a expiré. Merci de télécharger un certificat valide.",
            failedToDecode: "Pas de certificat valide. Il est possible que ce type de certificat ne soit pas encore pris en charge. Merci de contacter le personnel.",
            failedToReadQr: "Échec de la lecture du code QR du certificat. Merci de télécharger une meilleure image.",
            failedUpload: "Le téléchargement du certificat a échoué en raison d'une erreur inconnue. Merci de réessayer ou informer le personnel ou Tastier.",
            failedInvalidMode: "Ce certificat ne répond malheureusement pas aux exigences. Merci de télécharger un certificat différent.",
            failedIdDocUnkown: "L'ID ne peut pas être lu. Merci de télécharger une bonne image d'une pièce d'identité officielle avec photo. Utilise un type d'identification aussi commun que possible.",
            failedIdDocInvalid: "Cette carte d'identité ne correspond pas au certificat. Merci de télécharger une carte d'identité différente.",
            failedMissmatch: "Les certificats ne concordent pas (date de naissance ou nom).",
            failedDuplicate: "Le deuxième certificat est du même type ou identique au premier.",
            uploadCertName: "Certificat de vaccination / guérison",
            uploadCertDesc: "Capture d'écran ou photo du QR code de ton Certificat Covid",
            uploadSecondaryCertName: "Certificat de test",
            uploadSecondaryCertDesc: "nécessaire si le certificat 2G date de plus de 4 mois",
            uploadIdName: "Carte d'identité",
            uploadIdDesc: "Capture d'écran ou photo d'une carte d'identité officielle avec photo",
            verifyBtn: "Contrôler (~10 s)",
            stateUploadingFiles: "En cours de chargement...",
            stateValidatingCertificate: "Vérification du certificat...",
            stateValidatingIdentity: "Vérification de l'identité...",
            stateDecryptAndStore: "Dernières étapes...",
            submit: "Soumettre",
            back: "Revenir en arrière",
            failed: "Les données n'ont pas pu être sauvegardées.",
            disablePrivate: "Tu surfes en <b>MODE PRIVÉ / INCOGNITO</b>. Afin d'éviter de devoir saisir tes données à nouveau la prochaine fois, quitte le mode privé et recommence.",
        },
        minimumAgePopover: {
            title: "Vérification de l'Âge",
            text: "As-tu au moins {0} ans ? Des contrôles sont possibles.",
            confirm: "Oui",
            cancel: "Non",
        },
        fulfillmentPopover: {
            title: "Confirmation",
            currentTime: "Heure actuelle",
            emptyGroup: "Sans allocation",
            didYouGetEverything: "Tu as tout reçu?",
            didYouGetWholeOrder: "Par la présente, tu confirmes la réception de la commande complète. Tu as tout reçu?",
            showWhenPickingUpOrder: "Affiche cet écran lorsque tu viens chercher ta commande. Clique sur le bouton lorsque tu l'as reçue.",
            yesGotIt: "Oui, reçu",
            readyForPickUp: "Prêt à être récupérée",
            xItemsInMyOrder: "{0}x article(s) dans ma commande",
        },
        addToCartPopover: {
            price: "Prix",
            optional: "Optionnel",
            optionSing: "option",
            optionPlur: "options",
            chooseExact: "Sélectionne {0} {1}",
            chooseMin: "Sélectionne au moins {0} {1}",
            chooseUpTo: "Optionnel. Sélectionne au maximum {0} {1}",
            chooseBetween: "Sélectionne {0} - {1} options",
            upToTotalItems: "Au total, jusqu'à {0} articles",
            chooseOption: "Sélectionne tes options",
            loadingOptions: "Les options sont chargées...",
            failedLoadingOptions: "Les options n'ont pas pu être chargées.",
            adding: "...",
        },
        signin: {
            title: "Login",
            email: "E-mail",
            password: "Mot de passe",
            resetPasswordTitle: "Modification du Mot de Passe",
            repeatPassword: "Répéter le mot de passe",
            resetPassword: "Réinitialiser le mot de passe",
            setNewPassword: "Définir un Nouveau Mot de Passe",
            reset: "Réinitialiser",
            loginWith: "Se connecter via",
            login: "Se Connecter",
            signup: "S'Inscrire",
            logout: "Se Déconnecter",
            backToLogin: "Retourner au login",
            checkYourInbox: 'E-mail envoyé avec succès. Merci de vérifier ta boîte de réception et éventuellement ton courrier indésirable. Merci de marquer Tastier comme expéditeur sûr ou "Pas de Spam".',
            resetSuccess: "Ton mot de passe a été changé avec succès. Tu peux dès à présent te connecter avec ce dernier.",
            resetFailed: "Cette adresse e-mail n'existe pas auprès de Tastier. Merci de vérifier les informations.",
            signinFailed: "Login erroné. Merci de vérifier les informations. Ou inscris-toi à la place, pour créer un nouveaux compte.",
            externalAuthFailed: "Login via Facebook / Google / LinkedIn erroné. Merci de fermer l'onglet de navigation de ce fournisseur et d'essayer à nouveau.",
        },
        signup: {
            title: "Inscription",
            firstName: "Prénom",
            lastName: "Nom",
            phoneNumber: "Numéro de téléphone",
            zip: "Code postal (du lieu de résidence)",
            disclaimer: 'Je confirme avoir lu, compris et accepté les <a href="https://www.tastier.ch/conditions-dutilisation-pour-les-utilisateurs/" target="_blank">CU</a> et la <a href="https://www.tastier.ch/dataprivacy-fr/" target="_blank">politique de confidentialité</a> de Tastier SA. Il est possible que tu reçoives à l\'occasion des communications de Tastier, dont tu peux te désabonner à tout moment.',
            submit: "S'Inscrire",
            signin: "Se connecter avec un compte existant",
            signupWithMail: "S'inscrire par e-mail",
            signupFailed: "L'inscription n'a pas pu être finalisée.",
            emailConfirmSuccess: "E-mail confirmé avec succès. Merci beaucoup!",
            emailConfirmFailed: "L'e-mail n'a pas pu être confirmé.",
            emailAlreadyUsed: "Cet e-mail est déjà utilisé. Va à la connexion.",
        },
        enterCode: {
            title: "Saisir le Code",
            codeVerificationFailed: "Code invalide",
            digitCode: "Code à 6 chiffres",
            pasteCode: "Insérer le code du presse-papiers",
        },
        profile: {
            title: "Profil",
            emailConfirmed: "Confirmé",
            emailUnconfirmed: "Non confirmé",
            changePassword: "Changer le mot de passe",
            currentPassword: "Mot de passe actuel",
            newPassword: "Nouveau mot de passe",
            onlyImageFiles: "Merci de sélectionner un fichier image ou PDF.",
            updateBtn: "Sauvegarder",
            resendConfirmation: "Renvoyer l'e-mail de confirmation",
            failedResend: "L'e-mail n'a pas pu être envoyé. Merci de réessayer.",
            failedSave: "Les changements du profil n'ont pas pu être sauvegardés. Merci de réessayer.",
            profileSaved: "Profil actualisé avec succès",
            confirmationSent: 'E-mail envoyé avec succès. Merci de vérifier ta boîte de réception et éventuellement ton courrier indésirable. Merci de marquer Tastier comme expéditeur sûr ou "Pas de Spam".',
        },
        creditCard: {
            title: "Moyen de Paiement",
            failedRemove: "Le moyen de paiement n'a pas pu être effacé.",
            expired: "Expiré",
            ccHolder: "Nom sur la carte",
            ccNumber: "Numéro de carte",
            ccExpiry: "Date d'expiration",
            ccCvc: "CVC",
            confirmDelete: "Veux-tu supprimer définitivement ce moyen de paiement?",
            deleteBtn: "Effacer",
        },
        orderHistory: {
            title: "Commandes",
            confirmation: "Afficher la confirmation",
            loadingOrders: "Commandes en cours de chargement...",
            noOrders: "Aucune commande disponible",
        },
        paymentHistory: {
            title: "Paiements",
            noPayments: "Aucun paiement disponible",
            loadingPayments: "Paiements en cours de chargement...",
        },
        receipt: {
            title: "Commande",
            loading: "La commande est chargée...",
            sendReceipt: "Envoyer le reçu",
            sendReceiptEmail: "Adresse e-mail",
            receiptPrinted: "Travail d'impression envoyé",
            total: "Total",
            failedLoadingOrder: "La commande n'a pas pu être chargée.",
            failedSendReceipt: "Le reçu n'a pas pu être envoyé.",
            payment: "Paiement",
            printReceipt: "Imprimer le Reçu",
            receipt: "Reçu",
        },
        help: {
            helpTitle: "Feedback",
            helpLead: "Nous nous réjouissons de ton retour!",
            helpText: "Évalue Tastier, donne un feedback, annonce un problème ou pose une question. En cas d'urgence, tu peux nous atteindre par téléphone.<br /><br />Merci de donner un feedback relatif à une prestation de service d'une exploitation (repas, boissons, service, etc.) à l'exploitant concerné.",
            rateTastierBtn: "Évaluer Tastier",
            reportProblemBtn: "Annoncer un problème / Poser une question",
            issueTitle: "Demande de support Tastier",
            rateTitle: "Évaluation de Tastier",
            rateLead: "Dis nous à quel point Tastier te plaît!",
            rateText: "Ton évaluation nous aide à améliorer et développer Tastier. Échelle: 1 étoile = Très mauvais, 5 étoiles = Super",
            rating: "Évaluation",
            howImprove: "Comment Tastier peut s'améliorer?",
            reportProblem: "Qu'est-ce qui ne fonctionne pas bien? Comment et quand apparaît l'erreur?",
            sendBtn: "Envoyer",
            ratingSuccessful: "Évaluation envoyée. Merci!",
            reportIssueSuccessful: "Demande de support transmise. Nous reviendrons dès que possible vers toi.",
            failedRate: "L'évaluation n'a pas pu être envoyée.",
            failedReportIssue: "La demande de support n'a pas pu être transmise.",
        },
        navigation: {
            profile: "Profil",
            leaveTable: "Quitter",
            help: "Feedback",
            creditCards: "Moyens de Paiement",
            reports: "Rapports",
            orderHistory: "Commandes",
            paymentHistory: "Paiements",
            login: "Se Connecter",
            signup: "S'Inscrire",
            logout: "Se Déconnecter",
            guest: "Invité",
            switchIdentity: "Continuer à Saisir",
        },
        documents: {
            loading: "En cours de chargement...",
            failedToLoad: "Les documents n'ont pas pu être chargés.",
            noData: "Aucun document n'est actuellement publié.",
        },
        covid: {
            title: "COVID-19 | Tastier",
            letsgo: "C'est Parti",
            checkout: "Quitter le Site",
            clickBeforeYouGo: "Ne pas supprimer les données / l'historique du navigateur, afin que tu n'aies pas à saisir tes données à nouveau la prochaine fois.",
            guestNumber: "Numéro de client",
            validatingCertificate: "est en cours de validation...",
            welcome: "Bienvenue!",
        },
        bill: {
            title: "Payer",
            waitingForOrder: 'Transmission de l\'addition...<br />Rien n\'apparaît? Cela ne devrait être le cas. Il est conseillé de cliquer sur "Quitter" en haut à droite et d\'essayer à nouveau ou de contacter Tastier, sous "Feedback"',
            discount: "Rabais",
            continue: "Continuer",
            fullyPaidItems: "Articles Payés Intégralement",
            paid: "Payé",
            exclTip: "excl. pourboire",
            clearSelection: "Annuler la sélection",
            noOrderYet: "Tout est payé, merci!",
            fullyPaid: "Addition Payée Intégralement",
            allItems: "Tous les articles impayés",
            selectedItems: "article sélectionné",
            selectAll: "Tout sélectionner",
        },
        messages: {
            unauthorizedPleaseRefresh: "Ta session a expiré. La page va se recharger, merci de réessayer.",
        },
        general: {
            pleaseSelect: "Merci de sélectionner",
            close: "Fermer",
            done: "Fini",
            continue: "Continuer",
            ok: "Ok",
            edit: "Modifier",
            save: "Sauvegarder",
            add: "Ajouter",
            cancel: "Annuler",
            confirm: "Confirmer",
            understood: "Compris",
            operationFailed: "L'opération n'a pas pu être réalisée.",
            optional: "optionnel",
            verify: "Vérifier",
            today: "Aujourd'hui",
            date: "Date",
            time: "Heure",
            accept: "Accepter",
            yes: "Oui",
            shortWeekDay: {
                Sunday: "dim",
                Monday: "lun",
                Tuesday: "mar",
                Wednesday: "mer",
                Thursday: "jeu",
                Friday: "ven",
                Saturday: "sam",
            },
            copied: "Copié!",
        },
        passwordStrength: {
            minLength: "Minimum 8 caractères",
            upperCase: "Minimum 1 majuscule",
            lowerCase: "Mininum 1 minuscule",
            digit: "Minimum 1 chiffre",
        },
        enums: {
            cancellationMode: {
                Amount: "Montant manuel",
                Positions: "Postes individuels",
                WholeOrder: "Commande entière",
            },
            paymentMethodMode: {
                Online: "En ligne",
                Offline: "Hors ligne",
            },
            serviceType: {
                Covid: "Vérification Covid",
                Documents: "Documents",
                Order: "Commander",
                Ticketing: "Billets",
                Website: "Site Web",
                Offer: "Offre",
                Pay: "Payer",
                RoomPlan: "Plan de salle",
            },
        },
        preloadingSteps: {
            assets: "Images / Assets en cours de chargement...",
            domStructure: "Dom structure en création...",
            identity: "Identité et Websockets en cours de chargement...",
            paymentProvider: "Prestataire de service de paiement en cours de vérification...",
        },
        voucher: {
            invalidCode: "Code invalide",
            codeExpired: "Code expiré",
            codeNotApplicable: "Code non applicable",
            codeUsed: "Code épuisé",
            voucherCodeAlreadyApplied: "Code déjà appliqué"
        },
        addToHomeScreen: {
            title: "Désolé, utilisateur d'Apple ! Pour recevoir des notifications, suis les étapes ci-dessous. Ceci ajoutera Tastier à ton Écran d'Accueil (ressemble à une app).",
            step1: "1. Clique" + '<img class="shareicon" src="/assets/img/app/iphone-share.png" alt="the Share button" height="20" width="15">' + ", fais défiler vers le bas, \"Sur l'écran d'accueil\"" + '<img class="addtohomescreenicon" src="/assets/img/app/iphone-add-to-home-screen.png" alt="the Add to home screen button" height="20" width="19">' + '"Ajouter"',
            step2: "2. Clique l'icône de l'app " + '<img class="shareicon" src="/assets/img/app/apple-touch-icon.png" alt="the Share button" height="22" width="22">' + " sur l'Écran d'Accueil.",
            step3: "3. Ferme cet onglet du navigateur.",
        },
        app: {
            title: "Application mobile Tastier",
        },
        paymentMethodsReport: {
            paymentMethodsReport: "Rapport sur les moyens de paiement",
            paymentMethod: "Moyen de paiement",
            netQuantity: "Nombre Net",
            grossSalesNetChfInclTip: "Chiffre d'affaires brut Net CHF y compris pourboires",
            grossSalesPercent: "Chiffre d'affaires brut %",
            cancellationQuantity: "Nombre d'annulations",
            quantity: "Nombre",
            grossSalesAvg: "Chiffre d'affaires brut Ø CHF",
            tipNet: "Pourboire Net CHF",
            grossNetSales: "Chiffre d'affaires brut Net CHF",
            dateRangeGenerated: "Généré <b>{0}</b></br>Début <b>{1}</b></br>Fin <b>{2}</b>",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Aucun moyen de paiement configuré",
        },
        temporaryChange: (values) => {
            temporaryChangeTranslations(trans, Language.French, values);
        },
    };
};

const setItalian = () => {
    trans = {
        allocation: {
            headline: "Servito meglio",
            scanQrBtn: "Scannerizzare il Codice QR",
            scanHint: "Fare clic sul pulsante per iniziare",
            disclaimer: 'Utilizzando i servizi di Tastier confermo di aver letto, compreso e accettato le <a href="https://www.tastier.ch/condizioni-duso-per-gli-utenti/" target="_blank">CU</a> e <a href="https://www.tastier.ch/dataprivacy-it/" target="_blank">l\'informativa sulla privacy</a> di Tastier SA.',
            cameraFailed: "Accesso alla telecamera negato. Consentire a Tastier di accedere alla telecamera nelle impostazioni del browser (cancellare i dati del sito web / impostazioni) e riprovare.",
            tableDoesNotExist: "Purtroppo, questo numero non è attivato al momento. Si prega di correggere l'iscrizione o di contattare il personale o Tastier.",
            locationSuspended: "Purtroppo, questa ubicazione non è attualmente attivata. Si prega di contattare il personale o Tastier.",
            allocationFailed: "Purtroppo, il check-in non è riuscito. Si prega di ricaricare la pagina e riprovare.",
            title: "Benvenuto",
            enterCode: "Inserire il Codice a 6 Cifre",
            or: "o",
            doYouHaveOpenBill: "Hai un ordine / fattura aperto?<br />Ripeti la procedura che ti ha portato qui (ad es., clicca sul link o sul pulsante, scansiona il codice QR).",
        },
        notification: {
            allow: "Sì",
            dontAllow: "No",
            notificationPermission: "Vuoi ricevere una notifica quando il tuo ordine sarà pronto? In caso contrario, dovrai controllare frequentemente il tuo browser per non perdere l'ordine.",
            notifiedWhenOrderReadyWithDuration: "Sarai avvisato quando il tuo ordine sarà pronto per il ritiro. Tempo di attesa previsto (indicativo, può variare in qualsiasi momento):",
            notifiedWhenOrderReadyWithPosition: "Sarai avvisato quando il tuo ordine sarà pronto per il ritiro. Posizione attuale nella lista d'attesa:",
            notificationsDenied: "Hai rifiutato le notifiche. Non chiudere questa scheda del browser e controllala regolarmente per eventuali aggiornamenti.",
            enableNotificationFailed: "Il tuo browser / dispositivo non può ricevere notifiche. Non chiudere questa scheda del browser e controllala regolarmente per eventuali aggiornamenti.",
            checkIfPrivateMode: "Si consiglia di non utilizzare la modalità privata / incognito la prossima volta.",
            onMyWay: "Mostrare Schermata di Ritiro",
            pickUpOrderTitle: "Ritirare l'ordine",
            orderReadyToPickUp: "Il tuo ordine è pronto per il ritiro",
            orderScheduled: "Il tuo ordine sarà pronto per essere ritirato a breve",
            browserNotSupportNotifications: "Il tuo browser / dispositivo Apple non può ricevere notifiche. Non chiudere questa scheda del browser e controllala regolarmente per eventuali aggiornamenti.",
        },
        order: {
            title: "Ordine",
            loadingOffer: "Offerta in fase di caricamento...",
            itemsSelected: "{0} articolo/i selezionato/i",
            noOffer: "Purtroppo non c'è nessuna offerta disponibile al momento.",
            cancellationSuccessful: "Cancellazione riuscita",
            cancel: "Annullare"
        },
        cart: {
            title: "Carrello",
            itemsSelected: "{0} articolo/i",
            failedToAdd: "L'articolo non può essere aggiunto.",
            failedToRemove: "L'articolo non può essere rimosso.",
            failedToChange: "L'articolo non può essere modificato.",
            paymentBlockingCart: "Il carrello non può essere modificato mentre un pagamento è in corso.",
            minimumChf: "almeno {0}",
            noItems: "Nessun articolo è stato ancora aggiunto al carrello.",
            backToOverview: "Alla panoramica dell'offerta",
            haveItemsInCart: "Hai articoli nel tuo carrello di {0}. Se continui, il tuo carrello verrà cancellato.",
        },
        print: {
            orderReceiptPrinted: "Lavoro di stampa inviato",
            failedPrintReceipt: "Lavoro di stampa fallito",
            noProductionSiteEnabledForRoom: "A questo tavolo / sala non è assegnata alcuna stampante per ricevute attiva.",
            printReceipt: "Stampare la Ricevuta",
        },
        pay: {
            title: "Pagamento",
            discount: "Sconto",
            total: "Total",
            paying: "Pagando...",
            disclaimer: 'Si applica: Tastier <a href="https://www.tastier.ch/condizioni-duso-per-gli-utenti/" target="_blank">CU</a> & <a href="https://www.tastier.ch/dataprivacy-it/" target="_blank">privacy</a>, CG del fornitore.',
            contactingAquirer: "Si prega di aspettare...",
            signup: "Registrare",
            signupBenefits: "Opzionale. Vantaggi: Salvare i mezzi di pagamento, ricevute automaticamente via e-mail, cronologia degli ordini",
            btnFailed: "Fallito",
            btnSuccessful: "Riuscito",
            preparingCardForm: "Caricamento modulo...",
            failedAuthorization: "Il mezzo di pagamento non ha potuto essere addebitato.",
            failedCartIsOutdated: "Hai cercato di pagare un carrello non aggiornato, per favore aggiorna il sito web.",
            failedCartIsEmpty: "Stai cercando di pagare un carrello vuoto.",
            failedOfferExpired: "Almeno un articolo del tuo carrello non è più disponibile.",
            failedOrderIsClosed: "L'ordine è già pagato per intero.",
            orderWithStaff: "Ordinare dal personale",
            order: "Ordinare",
            ordering: "Ordinare...",
            provideEmailMessage: "Inserisci il tuo indirizzo e-mail o registrati",
        },
        done: {
            fullyPaid: "Conto completamente pagato",
            startOver: "Continuare",
            signupAndReceipt: "Ricevere La Ricevuta & Registrare",
            getReceipt: "Ricevere La Ricevuta",
            disclaimer: "È possibile ricevere occasionalmente comunicazioni da Tastier, da cui è possibile annullare l'iscrizione in qualsiasi momento.",
            signupAndReceiptBtn: "Registrare e Ricevere la Ricevuta",
            weSentReceipt: "Abbiamo inviato la tua ricevuta a",
            weSentConfirmation: "Abbiamo inviato la conferma a",
            failedSignup: "La registrazione è fallita. Si prega di riprovare.",
            onlyReceipt: "Solo ricevere la ricevuta",
            signupHintTitle: "Ricevuta via e-mail",
            signupHintText: "Inserisci la tua email per ricevere una ricevuta. E imposta una password per rendere ancora più facile pagare con un account Tastier la prossima volta (senza inserire il tuo metodo di pagamento) e per farti inviare automaticamente la ricevuta di Tastier.",
            trxCheckingTitle: "Pagamento in corso",
            trxCheckingText: "Si prega di attendere...",
            trxSuccessTitle: "Pagamento riuscito",
            trxDeclinedTitle: "Pagamento fallito",
            trxDeclinedText: "Si prega di riprovare",
            trxFailedCheckingTitle: "Pagamento non confermato",
            trxFailedCheckingText: "Limite di tempo superato",
            backToOrder: "Effettuare un Nuovo Ordine",
            backToPayment: "Effettuare un nuovo pagamento",
            displayOrderBtn: "Mostrare l'Ordine",
            displayPaymentBtn: "Visualizzare il Pagamento",
            title: "Ricevuta & Altro",
            more: "Altro",
            displayOrderHeadline: "Il Mio Ordine",
            displayPaymentHeadline: "Il mio Pagamento",
            signup: "Registrare",
            unpaid: "Non pagato",
        },
        cancelOrderPopover: {
            cancellationFailed: "Non è stato possibile annullare l'ordine.",
            title: "Annullamento",
            offlineMode: "Rimborso offline",
            wholeOrderText: "L'intero ordine verrà annullato.",
            yesCancel: "Si, annullare",
        },
        orderReceivedPopover: {
            plannedPickUpTime: "Orario di ritiro previsto",
            received: "Ordine Ricevuto",
            hint: '"Tastier" apparirà sul tuo estratto conto',
            receiptAndMore: "Ricevuta & Altro",
            more: "Altro",
            copyAddress: "Copiare l’Indirizzo",
            googleMapsLocation: "Posizione su Google Maps",
        },
        paymentReceivedPopover: {
            received: "Pagamento ricevuto",
            unpaid: "Non pagato",
            more: "Altro",
            fullyPaid: "Conto completamente pagato",
        },
        tableSelectionPopover: {
            title: "Selezione del tavolo",
            tableNumber: "Numero del tavolo",
            welcomeTo: "Benvenuti al",
            hint: "Chiedi al cameriere il tuo numero del tavolo se non è indicato o se ci sono problemi.",
        },
        tableInfoPopover: {
            title: "Dove vuoi andare?",
            textFieldLbl: "Destinazione esatta (persona / tavolo / area)",
            hint: "Si prega di inserire la destinazione esatta, in modo da poterla poi comprendere in modo chiaro e inequivocabile nel luogo in cui si è stati.",
        },
        phoneNumberPopover: {
            title: "Completamento Dei Dati",
            phoneNumber: "Numero di telefono",
            disclaimer: "Si prega di completare queste informazioni",
            submitBtn: "Salvare",
            failed: "Non è stato possibile salvare i dati.",
        },
        covidSignupPopover: {
            title: "Controllo Covid",
            certificateTitle: "Documenti richiesti",
            createAccount: "La registrazione permanente semplifica le visite future, a tutti i luoghi Tastier",
            deleteAfterDays: "Inserimento dei dati solo per uso una tantum / a breve termine",
            signupBtn: "Registrare + Inserire i Dati",
            signInBtn: "Log In",
            onlyCoronaBtn: "Inserire i Dati",
            firstName: "Nome",
            lastName: "Cognome",
            birthday: "Data di nascita",
            phone: "Numero di telefono",
            disclaimer: 'Confermo di aver letto, compreso e accettato le <a href="https://www.tastier.ch/condizioni-duso-per-gli-utenti/" target="_blank">CU</a> e <a href="https://www.tastier.ch/dataprivacy-it/" target="_blank">l\'informativa sulla privacy </a> di Tastier SA.',
            certDataProtection: 'La <a href="https://www.tastier.ch/dataprivacy-it/" target="_blank">protezione dei dati</a> è importante per noi. Il certificato viene controllato solo per la validità, non viene memorizzato. Nessun trasferimento di dati / uso dei documenti per altri scopi.',
            certificateExpired: "Questo certificato non è più valido. Si prega di caricarne uno nuovo.",
            failedBecauseInvalid: "Questo certificato non è valido o è scaduto. Si prega di caricare un certificato valido.",
            failedToDecode: "Non è un certificato valido. È possibile che questo tipo di certificato non sia ancora supportato. Si prega di contattare lo staff.",
            failedToReadQr: "Impossibile leggere il codice QR del certificato. Si prega di caricare un'immagine migliore.",
            failedUpload: "Caricamento del certificato fallito a causa di un errore sconosciuto. Si prega di riprovare o di avvisare lo staff o Tastier.",
            failedInvalidMode: "Spiacente, questo certificato non soddisfa i requisiti. Si prega di caricare un altro certificato.",
            failedIdDocUnkown: "L'ID non può essere letto. Si prega di caricare una buona immagine di un documento d'identità con foto ufficiale. Usa un tipo di ID il più comune possibile.",
            failedIdDocInvalid: "Questa carta d'identità non corrisponde al certificato. Si prega di caricare una carta d'identità diversa.",
            failedMissmatch: "I certificati non corrispondono (data di nascita o nome).",
            failedDuplicate: "Il secondo certificato ha lo stesso tipo o è identico al primo.",
            uploadCertName: "Certificato di vaccinazione / recupero",
            uploadCertDesc: "Screenshot o foto del codice QR del tuo Certificato Covid",
            uploadSecondaryCertName: "Certificato di prova",
            uploadSecondaryCertDesc: "richiesto se il certificato 2G è più vecchio di 4 mesi",
            uploadIdName: "Carta d'identità",
            uploadIdDesc: "Screenshot o foto di una carta d'identità ufficiale con foto",
            verifyBtn: "Controllare (~10 s)",
            stateUploadingFiles: "In fase di caricamento...",
            stateValidatingCertificate: "Certificato in fase di controllo...",
            stateValidatingIdentity: "ID in fase di controllo...",
            stateDecryptAndStore: "Passi finali...",
            submit: "Inviare",
            back: "Tornare indietro",
            failed: "Non è stato possibile salvare i dati.",
            disablePrivate: "Si naviga in <b>MODALITÀ PRIVATO / INCOGNITO</b>. Per evitare di dover inserire nuovamente i dati la prossima volta, lascia la modalità privata e ricomincia da capo.",
        },
        minimumAgePopover: {
            title: "Controllo dell'Età",
            text: "Hai almeno {0} anni? I controlli sono possibili.",
            confirm: "Sì",
            cancel: "No",
        },
        fulfillmentPopover: {
            title: "Conferma",
            currentTime: "Ora corrente",
            emptyGroup: "Senza assegnazione",
            showWhenPickingUpOrder: "Mostra questa schermata al momento del ritiro dell'ordine. Clicca sul pulsante quando l'hai ricevuto.",
            didYouGetEverything: "Hai ricevuto tutto?",
            didYouGetWholeOrder: "Con la presente si conferma la ricezione dell'ordine completo. Hai ricevuto tutto?",
            yesGotIt: "Sì, ricevuto",
            readyForPickUp: "Pronto per il ritiro",
            xItemsInMyOrder: "{0}x articolo/i nel mio ordine",
        },
        addToCartPopover: {
            price: "Prezzo",
            optional: "Opzionale",
            optionSing: "opzione",
            optionPlur: "opzioni",
            chooseExact: "Seleziona {0} {1}",
            chooseMin: "Seleziona almeno {0} {1}",
            chooseUpTo: "Opzionale. Seleziona fino a {0} {1}",
            chooseBetween: "Seleziona {0} - {1} opzioni",
            upToTotalItems: "In totale fino a {0} articoli",
            chooseOption: "Seleziona le tue opzioni",
            loadingOptions: "Le opzioni sono caricate...",
            failedLoadingOptions: "Le opzioni non possono essere caricate.",
            adding: "...",
        },
        signin: {
            title: "Login",
            email: "E-Mail",
            password: "Password",
            resetPasswordTitle: "Reset della password",
            repeatPassword: "Ripetere la password",
            resetPassword: "Reset della password",
            setNewPassword: "Impostare Nuova Password",
            reset: "Reset",
            loginWith: "Log in con",
            login: "Log In",
            signup: "Registrare",
            logout: "Disconnettere",
            backToLogin: "Ritorna al login",
            checkYourInbox: 'Ti abbiamo inviato un\'e-mail per reimpostare la tua password, si prega di controllare la tua inbox o la tua cartella spam. Si prega di contrassegnare Tastier come mittente sicuro o "Non è spam".',
            resetSuccess: "La tua password è stata modificata con successo. Ora è possibile effettuare il login con esso.",
            resetFailed: "Questa e-mail non esiste con Tastier. Si prega di controllare i dati inseriti.",
            signinFailed: "Login fallito. Si prega di controllare i dati di accesso. O registrarsi invece per creare un nuovo account.",
            externalAuthFailed: "Login via Facebook / Google / LinkedIn fallito. Chiudere la scheda del browser di questo provider e riprovare.",
        },
        signup: {
            title: "Registrazione",
            firstName: "Nome",
            lastName: "Cognome",
            phoneNumber: "Numero di telefono",
            zip: "Codice postale (del luogo di residenza)",
            disclaimer: 'confermo di aver letto, compreso e accettato le <a href="https://www.tastier.ch/condizioni-duso-per-gli-utenti/" target="_blank">CU</a> e <a href="https://www.tastier.ch/dataprivacy-it/" target="_blank">l\'informativa sulla privacy</a> di Tastier SA. Potrai ricevere occasionalmente comunicazioni di Tastier ma potrai sempre cancellarti.',
            submit: "Registrare",
            signin: "Login con accesso esistente",
            signupWithMail: "Registrare via e-mail",
            signupFailed: "La registrazione non ha potuto essere completata.",
            emailConfirmSuccess: "E-mail confermata con successo. Grazie mille!",
            emailConfirmFailed: "L'e-mail non ha potuto essere confermata.",
            emailAlreadyUsed: "Questa e-mail è già presa. Vai al login.",
        },
        enterCode: {
            title: "Inserire il Codice",
            codeVerificationFailed: "Codice non valido",
            digitCode: "Codice a 6 cifre",
            pasteCode: "Incollare il codice",
        },
        profile: {
            title: "Profilo",
            emailConfirmed: "Confermato",
            emailUnconfirmed: "Non confermato",
            changePassword: "Cambiare la password",
            currentPassword: "Password attuale",
            newPassword: "Nuova password",
            onlyImageFiles: "Si prega di selezionare un file immagine o PDF.",
            updateBtn: "Salvare",
            resendConfirmation: "Inviare di nuovo l'e-mail di conferma",
            failedResend: "Non è stato possibile inviare l'e-mail. Si prega di riprovare.",
            failedSave: "Non è stato possibile salvare le modifiche del profilo. Si prega di riprovare.",
            profileSaved: "Profilo aggiornato con successo",
            confirmationSent: 'E-mail inviata con successo. Si prega di controllare la tua inbox e la cartella spam. Si prega di contrassegnare Tastier come mittente sicuro o "Non è spam".',
        },
        creditCard: {
            title: "Mezzi di pagamento",
            failedRemove: "Non è stato possibile cancellare il mezzo di pagamento.",
            expired: "Scaduta",
            ccHolder: "Nome sulla carta",
            ccNumber: "Numero della carta",
            ccExpiry: "Data di scadenza",
            ccCvc: "CVC",
            confirmDelete: "Vuoi cancellare definitivamente questo mezzo di pagamento?",
            deleteBtn: "Eliminare",
        },
        orderHistory: {
            title: "Ordini",
            confirmation: "Mostrare la conferma",
            loadingOrders: "Gli ordini vengono caricati...",
            noOrders: "Nessun ordine disponibile",
        },
        paymentHistory: {
            title: "Pagamenti",
            noPayments: "Nessun pagamento disponibile",
            loadingPayments: "Gli pagamenti vengono caricati...",
        },
        receipt: {
            title: "Ordina",
            loading: "L'ordine è caricato...",
            sendReceipt: "Inviare la ricevuta",
            sendReceiptEmail: "Indirizzo e-mail",
            receiptPrinted: "Lavoro di stampa inviato",
            total: "Totale",
            failedLoadingOrder: "L'ordine non può essere caricato.",
            failedSendReceipt: "Non è stato possibile inviare la ricevuta.",
            payment: "Pagamento",
            printReceipt: "Stampare la Ricevuta",
            receipt: "Ricevuta",
        },
        help: {
            helpTitle: "Feedback",
            helpLead: "Ci farebbe piacere sentirvi!",
            helpText: "Valuta Tastier, dai un feedback, segnalaci un problema o fai una domanda.  Se è urgente, si prega di chiamarci.<br /><br />Si prega di inviare un feedback relativo ai servizi di un'azienda (cibo, bevande, servizio, ecc.) al rispettivo operatore.",
            rateTastierBtn: "Valutare Tastier",
            reportProblemBtn: "Segnalare un problema / Fare una domanda",
            issueTitle: "Richiesta di supporto di Tastier",
            rateTitle: "Valutazione di Tastier",
            rateLead: "Dicci come ti piace Tastier!",
            rateText: "La tua valutazione ci aiuta a migliorare e approfondire Tastier. Scala: 1 stella = molto male, 5 stelle = fantastico",
            rating: "Valutazione",
            howImprove: "Come può Tastier migliorare?",
            reportProblem: "Cosa non funziona bene? Come e quando si presenta l'errore?",
            sendBtn: "Inviare",
            ratingSuccessful: "Valutazione inviata. Grazie mille!",
            reportIssueSuccessful: "Richiesta di supporto inviata. Vi risponderemo il prima possibile.",
            failedRate: "Non è stato possibile inviare la valutazione.",
            failedReportIssue: "Non è stato possibile inviare la richiesta di supporto.",
        },
        navigation: {
            profile: "Profilo",
            leaveTable: "Uscire",
            help: "Feedback",
            creditCards: "Mezzi di Pagamento",
            reports: "Rapporti",
            orderHistory: "Ordini",
            paymentHistory: "Pagamenti",
            login: "Log In",
            signup: "Registrare",
            logout: "Disconnettere",
            guest: "Ospite",
            switchIdentity: "Continuare A Raccogliere",
        },
        documents: {
            loading: "Caricamento...",
            failedToLoad: "Non è stato possibile caricare i documenti.",
            noData: "Attualmente non è stato pubblicato alcun documento.",
        },
        covid: {
            title: "COVID-19 | Tastier",
            letsgo: "Andiamo",
            checkout: "Lasciare Il Luogo",
            clickBeforeYouGo: "Non cancellare i dati del browser / la cronologia, in modo da non dover inserire nuovamente i dati la prossima volta.",
            guestNumber: "Numero dell'ospite",
            validatingCertificate: "è in fase di convalida...",
            welcome: "Benvenuti!",
        },
        bill: {
            title: "Pagare",
            waitingForOrder: 'Chiamare il conto...<br />Non appare niente? Questo non doveva succedere. La cosa migliore è cliccare su „Uscire“, in alto a destra, e riprovare o contattare Tastier, vedi "Aiuto"',
            discount: "Sconto",
            continue: "Continuare",
            fullyPaidItems: "Articoli completamente pagati",
            paid: "Pagato",
            exclTip: "escl. mancia",
            clearSelection: "Annullare la selezione",
            noOrderYet: "Tutto è pagato, grazie!",
            fullyPaid: "Conto completamente pagato",
            allItems: "Tutti gli articoli non pagati",
            selectedItems: "Articoli selezionati",
            selectAll: "Selezionare tutto",
        },
        messages: {
            unauthorizedPleaseRefresh: "La tua sessione è finita. La pagina si ricaricherà, si prega di riprovare.",
        },
        general: {
            pleaseSelect: "Si prega di selezionare",
            close: "Chiudere",
            done: "Finito",
            continue: "Continuare",
            ok: "Ok",
            edit: "Modificare",
            save: "Salvare",
            add: "Aggiungere",
            cancel: "Cancellare",
            confirm: "Confirmare",
            understood: "Capito",
            operationFailed: "L'operazione non può essere eseguita.",
            optional: "opzionale",
            verify: "Verificare",
            today: "Oggi",
            date: "Data",
            time: "Ora",
            accept: "Accettare",
            yes: "Sì",
            shortWeekDay: {
                Sunday: "dom",
                Monday: "lun",
                Tuesday: "mar",
                Wednesday: "mer",
                Thursday: "gio",
                Friday: "ven",
                Saturday: "sab",
            },
            copied: "Copiato!",
        },
        passwordStrength: {
            minLength: "Almeno 8 caratteri",
            upperCase: "Almeno 1 lettera maiuscola",
            lowerCase: "Almeno 1 lettera minuscola",
            digit: "Almeno 1 numero",
        },
        enums: {
            cancellationMode: {
                Amount: "Importo manuale",
                Positions: "Singole voci",
                WholeOrder: "Ordine intero",
            },
            paymentMethodMode: {
                Online: "Online",
                Offline: "Offline",
            },
            serviceType: {
                Covid: "Controllo Covid",
                Documents: "Documenti",
                Order: "Ordinare",
                Ticketing: "Biglietti",
                Website: "Sito Web",
                Offer: "Offerta",
                Pay: "Pagare",
                RoomPlan: "Piano di sala",
            },
        },
        preloadingSteps: {
            assets: "Immagini / Assets sono caricate...",
            domStructure: 'La struttura „Dom" è in costruzione...',
            identity: "Identità e prese web sono caricate...",
            paymentProvider: "I fornitori di pagamento sono in fase di revisione...",
        },
        voucher: {
            invalidCode: "Codice non valido",
            codeExpired: "Codice scaduto",
            codeNotApplicable: "Codice non applicabile",
            codeUsed: "Codice esaurito",
            voucherCodeAlreadyApplied: "Codice già applicato"
        },
        addToHomeScreen: {
            title: "Spiacente, utente Apple! Segui questi passaggi per ricevere le notifiche. Questo aggiungerà Tastier alla schermata Home (sembra un'app).",
            step1: "1. Fare clic su" + '<img class="shareicon" src="/assets/img/app/iphone-share.png" alt="the Share button" height="20" width="15">' + ', scorrere in basso, "Aggiungi alla schermata Home"' + '<img class="addtohomescreenicon" src="/assets/img/app/iphone-add-to-home-screen.png" alt="the Add to home screen button" height="20" width="19">' + '"Aggiungere"',
            step2: "2. Fare clic sull'icona dell'app " + '<img class="shareicon" src="/assets/img/app/apple-touch-icon.png" alt="the Share button" height="22" width="22">' + " sulla schermata Home.",
            step3: "3. Chiude questa scheda del browser.",
        },
        app: {
            title: "App mobile Tastier",
        },
        paymentMethodsReport: {
            paymentMethodsReport: "Rapporto sui mezzi di pagamento",
            paymentMethod: "Mezzo di pagamento",
            netQuantity: "Numero Netto",
            grossSalesNetChfInclTip: "Fatturato lordo Netto CHF incl. mancia",
            grossSalesPercent: "Fatturato lorde %",
            cancellationQuantity: "Numero di annullamenti",
            quantity: "Numero",
            grossSalesAvg: "Fatturato lorde Ø CHF",
            tipNet: "Mancia Netta CHF",
            grossNetSales: "Fatturato lordo Netto CHF",
            dateRangeGenerated: "Generato <b>{0}</b></br>Inizio <b>{1}</b></br>Fine <b>{2}</b>",
        },
        paymentMethodSelector: {
            noPaymentMethodConfigured: "Nessun mezzo di pagamento configurato",
        },
        temporaryChange: (values) => {
            temporaryChangeTranslations(trans, Language.Italian, values);
        },
    };
};

switch (clientLanguage()) {
    case Language.English:
        setEnglish();

        if (isTestProject) {
            break;
        }

        //set datepicker local
        ($.fn.datepicker as any).dates["en-GB"] = {
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            today: "Today",
            monthsTitle: "Months",
            clear: "Clear",
            weekStart: 1,
            format: "dd.mm.yyyy",
        };
        break;
    case Language.German:
        setGerman();

        //set datepicker local
        ($.fn.datepicker as any).dates.de = {
            days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
            daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
            today: "Heute",
            monthsTitle: "Monate",
            clear: "Löschen",
            weekStart: 1,
            format: "dd.mm.yyyy",
        };
        break;
    case Language.French:
        setFrench();

        //set datepicker local
        ($.fn.datepicker as any).dates.fr = {
            days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            daysMin: ["D", "L", "Ma", "Me", "J", "V", "S"],
            months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            monthsShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Déc"],
            today: "Aujourd'hui",
            monthsTitle: "Mois",
            clear: "Effacer",
            weekStart: 1,
            format: "dd.mm.yyyy",
        };
        break;
    case Language.Italian:
        setItalian();

        //set datepicker local
        ($.fn.datepicker as any).dates.it = {
            days: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
            daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
            daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
            months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
            today: "Oggi",
            clear: "Cancella",
            weekStart: 1,
            format: "dd.mm.yyyy",
        };
        break;
    default:
        setGerman();

        ($.fn.datepicker as any).dates.de = {
            days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
            daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
            daysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
            monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
            today: "Heute",
            monthsTitle: "Monate",
            clear: "Löschen",
            weekStart: 1,
            format: "dd.mm.yyyy",
        };
        break;
}

function temporaryChangeTranslations(lit: any, language: Language, transVals?: Array<{ valueDe: string; valueEn: string; valueFr: string; valueIt: string }>) {
    if (transVals !== undefined && Object.keys(transVals).length > 0) {
        for (const key in transVals) {
            //find in trans
            const splits = key.split(".");
            let currentPointer = undefined as any;
            let c = 0;
            for (const spi in splits) {
                const spiV = splits[spi];
                c++;

                if (splits.length === c) {
                    if (currentPointer === undefined) break;

                    if (typeof currentPointer[spiV] !== "string") break;

                    switch (language) {
                        case Language.German:
                            currentPointer[spiV] = transVals[key].valueDe;
                            break;
                        case Language.English:
                            currentPointer[spiV] = transVals[key].valueEn;
                            break;
                        case Language.French:
                            currentPointer[spiV] = transVals[key].valueFr;
                            break;
                        case Language.Italian:
                            currentPointer[spiV] = transVals[key].valueIt;
                            break;
                    }

                    break;
                }

                if (currentPointer === undefined) currentPointer = lit[spiV];
                else currentPointer = currentPointer[spiV];

                if (currentPointer === undefined) break;
            }
        }
    } else {
        switch (language) {
            case Language.English:
                setEnglish();
                break;
            case Language.German:
                setGerman();
                break;
            case Language.French:
                setFrench();
                break;
            case Language.Italian:
                setItalian();
                break;
            default:
                setGerman();
                break;
        }
    }
}
